import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Hashmap: any;
  Time: any;
};

export type Address = {
  __typename?: 'Address';
  cityLocality: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  fullName: Scalars['String'];
  nickname?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  stateProvinceCode: Scalars['String'];
  street1: Scalars['String'];
  street2?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  cityLocality: Scalars['String'];
  companyName?: InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
  fullName: Scalars['String'];
  nickname?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  postalCode: Scalars['String'];
  stateProvinceCode: Scalars['String'];
  street1: Scalars['String'];
  street2?: InputMaybe<Scalars['String']>;
};

export type AddressValidationMessage = {
  __typename?: 'AddressValidationMessage';
  code: Scalars['ID'];
  message: Scalars['String'];
  type: Scalars['String'];
};

export type AddressValidationResponse = {
  __typename?: 'AddressValidationResponse';
  destination: Destination;
  messages: Array<AddressValidationMessage>;
  order: Order;
  valid: Scalars['Boolean'];
};

export type BalanceEntry = {
  __typename?: 'BalanceEntry';
  cashRemainingInCents: Scalars['Int'];
  createdAt: Scalars['Time'];
  id: Scalars['ID'];
  originalCashInCents: Scalars['Int'];
  products: Array<BalanceEntryProduct>;
  vendorDisplayName: Scalars['String'];
  vendorSale?: Maybe<VendorSale>;
};

export type BalanceEntryProduct = {
  __typename?: 'BalanceEntryProduct';
  originalQuantity: Scalars['Int'];
  productId: Scalars['String'];
  quantityRemaining: Scalars['Int'];
};

export type Book = {
  __typename?: 'Book';
  bookType: BookType;
  coverId: Scalars['ID'];
  createdAt: Scalars['Time'];
  destination: Destination;
  events?: Maybe<Array<LoadingEvent>>;
  extras?: Maybe<Array<Extra>>;
  giftMessage: Message;
  id: Scalars['ID'];
  order: Order;
  sku: Scalars['String'];
  state: ItemFulfillmentState;
  type: BookType;
};

export type BookLineItemInput = {
  coverId: Scalars['String'];
  quantity: Scalars['Int'];
};

export type BookStockEntry = {
  __typename?: 'BookStockEntry';
  covers: Array<StockEntry>;
  displayName: Scalars['String'];
  durations: Array<DurationStockEntry>;
  extras: Array<StockEntry>;
  id: Scalars['ID'];
  images?: Maybe<Array<Scalars['String']>>;
};

export enum BookType {
  FiveInch = 'five_inch'
}

export type Clip = {
  __typename?: 'Clip';
  endMs: Scalars['Int'];
  rotation: Scalars['Int'];
  startMs: Scalars['Int'];
};

export type ClipInput = {
  endMs: Scalars['Int'];
  rotation: Scalars['Int'];
  startMs: Scalars['Int'];
};

export type Cost = {
  __typename?: 'Cost';
  actualInCents: Scalars['Int'];
  currency: Currency;
  discountInCents: Scalars['Int'];
  listInCents: Scalars['Int'];
};

export type Costs = {
  __typename?: 'Costs';
  balanceUsed: CustomerBalance;
  product: Cost;
  shipping: Cost;
  tax: Cost;
  total: Cost;
};

export enum Currency {
  Usd = 'USD'
}

export type Customer = {
  __typename?: 'Customer';
  balance?: Maybe<CustomerBalance>;
  createdAt: Scalars['Time'];
  email: Scalars['String'];
  flagOrders?: Maybe<FlagInfo>;
  id: Scalars['ID'];
  paymentCustomerId: Scalars['ID'];
};

export type CustomerBalance = {
  __typename?: 'CustomerBalance';
  cashEntries: Array<BalanceEntry>;
  cashInCents: Scalars['Int'];
  products: Array<CustomerBalanceProduct>;
};

export type CustomerBalanceProduct = {
  __typename?: 'CustomerBalanceProduct';
  entries: Array<BalanceEntry>;
  product: Product;
  quantity: Scalars['Int'];
};

export type Design = {
  __typename?: 'Design';
  createdAt: Scalars['Time'];
  durationSeconds: Scalars['Int'];
  generation: Scalars['ID'];
  id: Scalars['ID'];
  manualGain?: Maybe<Scalars['Int']>;
  manualOrientation: Scalars['String'];
  media?: Maybe<Array<MediaEntry>>;
  orderId: Scalars['ID'];
  renders?: Maybe<Array<Render>>;
};

export type DesignResponse = {
  __typename?: 'DesignResponse';
  design: Design;
  order?: Maybe<Order>;
};

export type DesignWithDestinations = {
  __typename?: 'DesignWithDestinations';
  design?: Maybe<Design>;
  destinations?: Maybe<Array<Destination>>;
};

export type Destination = {
  __typename?: 'Destination';
  address?: Maybe<Address>;
  bookType?: Maybe<BookType>;
  books?: Maybe<Array<Book>>;
  coverId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['Time'];
  designId: Scalars['ID'];
  extras?: Maybe<Array<Extra>>;
  giftMessage?: Maybe<Message>;
  id: Scalars['ID'];
  /** As we begin to fulfill books they appear here. */
  items?: Maybe<Array<PackageItem>>;
  orderId: Scalars['ID'];
  quantity: Scalars['Int'];
  shippingLabels?: Maybe<Array<ShippingLabel>>;
  shippingServiceCode?: Maybe<Scalars['String']>;
  shippingSpeed?: Maybe<Scalars['String']>;
  state: Scalars['String'];
};

export type DestinationCosts = {
  __typename?: 'DestinationCosts';
  costs: Costs;
  destinationId: Scalars['ID'];
};

export type Device = {
  __typename?: 'Device';
  createdAt: Scalars['Time'];
  id: Scalars['ID'];
  metadata?: Maybe<Scalars['Hashmap']>;
  platform: Scalars['String'];
  token: Scalars['String'];
};

export type Discount = {
  __typename?: 'Discount';
  id: Scalars['ID'];
  oneTime: Scalars['Boolean'];
  type: DiscountType;
  value: Scalars['Int'];
};

export type DiscountInput = {
  id: Scalars['ID'];
  oneTime: Scalars['Boolean'];
  type: DiscountType;
  value: Scalars['Int'];
};

export enum DiscountType {
  Amount = 'amount',
  Book = 'book',
  Percent = 'percent'
}

export type DownloadResponse = {
  __typename?: 'DownloadResponse';
  href: Scalars['String'];
};

export type Dropoff = {
  __typename?: 'Dropoff';
  address?: Maybe<Scalars['String']>;
  device: Scalars['String'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  occurred_at: Scalars['String'];
  scanner_email: Scalars['String'];
  scanner_name: Scalars['String'];
};

export type DurationStockEntry = {
  __typename?: 'DurationStockEntry';
  cost: Cost;
  displayName: Scalars['String'];
  id: Scalars['ID'];
  ifLessThanDurationSec: Scalars['Int'];
  quantity: Scalars['Int'];
};

export type Event = {
  __typename?: 'Event';
  createdAt: Scalars['Time'];
  designId?: Maybe<Scalars['String']>;
  deviceId?: Maybe<Scalars['String']>;
  event: Scalars['String'];
  id: Scalars['ID'];
  metadata?: Maybe<Scalars['Hashmap']>;
  orderId?: Maybe<Scalars['String']>;
};

export type EventSubscription = {
  __typename?: 'EventSubscription';
  createdAt: Scalars['Time'];
  designId?: Maybe<Scalars['String']>;
  deviceId?: Maybe<Scalars['String']>;
  event: Scalars['String'];
  id: Scalars['ID'];
  metadata?: Maybe<Scalars['Hashmap']>;
  orderId?: Maybe<Scalars['String']>;
  unsubscribeOn?: Maybe<Scalars['String']>;
};

export type Extra = {
  __typename?: 'Extra';
  id: Scalars['ID'];
};

export type ExtraInput = {
  id: Scalars['ID'];
};

export type FlagInfo = {
  __typename?: 'FlagInfo';
  createdAt: Scalars['Time'];
  createdByEmail: Scalars['String'];
  createdByName: Scalars['String'];
  description?: Maybe<Scalars['String']>;
};

export type FlagInfoInput = {
  createdAt: Scalars['Time'];
  createdByEmail: Scalars['String'];
  createdByName: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
};

export type FormDownload = {
  __typename?: 'FormDownload';
  href?: Maybe<Scalars['String']>;
};

export type HelpScoutConversation = {
  __typename?: 'HelpScoutConversation';
  closedAt?: Maybe<Scalars['Time']>;
  createdAt: Scalars['Time'];
  id: Scalars['Int'];
  isDraft: Scalars['Boolean'];
  modifiedAt?: Maybe<Scalars['Time']>;
  number: Scalars['Int'];
  preview: Scalars['String'];
  status: Scalars['String'];
  subject: Scalars['String'];
  threadCount: Scalars['Int'];
};

export type HelpScoutConversationsResponse = {
  __typename?: 'HelpScoutConversationsResponse';
  conversations: Array<HelpScoutConversation>;
};

export enum ItemFulfillmentState {
  Archived = 'archived',
  Canceled = 'canceled',
  Fulfilled = 'fulfilled',
  Hold = 'hold',
  Ready = 'ready'
}

export type LabelDownload = {
  __typename?: 'LabelDownload';
  href?: Maybe<Scalars['String']>;
  pdf?: Maybe<Scalars['String']>;
  png?: Maybe<Scalars['String']>;
};

export type LoadingEvent = {
  __typename?: 'LoadingEvent';
  createdAt: Scalars['Time'];
  createdBy: Scalars['String'];
  id: Scalars['String'];
  type: Scalars['String'];
};

export type LoyaltyCodeResponse = {
  __typename?: 'LoyaltyCodeResponse';
  link: Scalars['String'];
  qr: QrCode;
};

export type ManyOrdersResponse = {
  __typename?: 'ManyOrdersResponse';
  orders: Array<Order>;
};

export type MediaEntry = {
  __typename?: 'MediaEntry';
  backgroundVolume: Scalars['Float'];
  clips: Array<Clip>;
  durationSeconds?: Maybe<Scalars['Int']>;
  encodeAttempts: Scalars['Int'];
  encodeProgress: Scalars['Float'];
  encodedLocation: Scalars['String'];
  format?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isVertical?: Maybe<Scalars['Boolean']>;
  mediaVolume: Scalars['Float'];
  mezzanineLocation: Scalars['String'];
  posterLocation: Scalars['String'];
  rotation?: Maybe<Scalars['Int']>;
  signedEncodedLocation?: Maybe<Scalars['String']>;
  signedPosterLocation?: Maybe<Scalars['String']>;
  signedThumbnailLocation?: Maybe<Scalars['String']>;
  signedVideoThumbnailLocation?: Maybe<Scalars['String']>;
  sizeKB?: Maybe<Scalars['Int']>;
  thumbnailLocation: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  videoThumbnailLocation: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
};

export type MediaEntryEdit = {
  backgroundVolume?: InputMaybe<Scalars['Float']>;
  clips?: InputMaybe<Array<ClipInput>>;
  mediaVolume?: InputMaybe<Scalars['Float']>;
};

export type MediaEntryInput = {
  durationSeconds?: InputMaybe<Scalars['Int']>;
  format?: InputMaybe<Scalars['String']>;
  location: Scalars['String'];
  sizeKB?: InputMaybe<Scalars['Int']>;
  type: Scalars['String'];
};

export type MediaInput = {
  /**
   * This will cause the method to error if the current generation value on this design does not
   * match the one passed. The generation value updates every time the design is changed.
   *
   * It is strongly recommended that you pass the value you got when you loaded the design or last changed it,
   * IF this is an autosave application (a situation where the design is saving itself). This will prevent
   * you from accidentally clobbering changes made in another tab or through a bug. If this change
   * is happening due to user action like clicking 'Save' it is recommended you do NOT set this,
   * as we don't want to block the user from saving intentionally even if it might overwrite something.
   */
  ifPrevGenerationMatches?: InputMaybe<Scalars['ID']>;
  media: Array<MediaEntryInput>;
};

export type Message = {
  __typename?: 'Message';
  body: Scalars['String'];
};

export type MessageInput = {
  body: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addDesign: DesignResponse;
  addDestination: Order;
  addExtra: Order;
  appendMedia: Design;
  applyDiscountCode: Order;
  completeFreeOrder: Order;
  createDraftOrder: NewOrderResponse;
  design: Design;
  editMedia: Design;
  emailDesignPreview: Design;
  eventOccurred: Event;
  registerDevice: Device;
  registerVendorSale: VendorSale;
  removeDestination: Order;
  removeExtra: Order;
  subscribe: EventSubscription;
  updateAddress: AddressValidationResponse;
  updateCover: Order;
  updateDeviceToken: Device;
  updateGiftMessage: Order;
  updateMedia: Design;
  updateMediaWithLocations: Design;
  updateOrientation: DesignResponse;
  updateQuantity: Order;
  updateShippingChoice: Order;
  updateVendorSaleCancellation: VendorSale;
};


export type MutationAddDesignArgs = {
  cloneDesignId?: InputMaybe<Scalars['ID']>;
  orderId: Scalars['ID'];
};


export type MutationAddDestinationArgs = {
  cloneDestinationId?: InputMaybe<Scalars['ID']>;
  designId: Scalars['ID'];
  orderId: Scalars['ID'];
};


export type MutationAddExtraArgs = {
  destinationId: Scalars['ID'];
  extra: ExtraInput;
};


export type MutationAppendMediaArgs = {
  designId: Scalars['ID'];
  media: Array<Scalars['ID']>;
};


export type MutationApplyDiscountCodeArgs = {
  discountId: Scalars['String'];
  orderId: Scalars['ID'];
};


export type MutationCompleteFreeOrderArgs = {
  orderId: Scalars['ID'];
};


export type MutationCreateDraftOrderArgs = {
  order: NewOrder;
};


export type MutationDesignArgs = {
  designId: Scalars['ID'];
};


export type MutationEditMediaArgs = {
  designId: Scalars['ID'];
  media: MediaEntryEdit;
  mediaEntryId: Scalars['ID'];
};


export type MutationEmailDesignPreviewArgs = {
  designId: Scalars['ID'];
  emailAddress: Scalars['String'];
  resumeLink?: InputMaybe<Scalars['String']>;
};


export type MutationEventOccurredArgs = {
  event: NewEvent;
};


export type MutationRegisterDeviceArgs = {
  device: NewDevice;
};


export type MutationRegisterVendorSaleArgs = {
  sale: NewVendorSale;
};


export type MutationRemoveDestinationArgs = {
  designId: Scalars['ID'];
  destinationId: Scalars['ID'];
  orderId: Scalars['ID'];
};


export type MutationRemoveExtraArgs = {
  destinationId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationSubscribeArgs = {
  subscription: NewSubscription;
};


export type MutationUpdateAddressArgs = {
  address: AddressInput;
  destinationId: Scalars['ID'];
};


export type MutationUpdateCoverArgs = {
  coverId: Scalars['ID'];
  destinationId: Scalars['ID'];
};


export type MutationUpdateDeviceTokenArgs = {
  deviceId: Scalars['ID'];
  newToken: Scalars['String'];
};


export type MutationUpdateGiftMessageArgs = {
  destinationId: Scalars['ID'];
  message: MessageInput;
};


export type MutationUpdateMediaArgs = {
  designId: Scalars['ID'];
  ifPrevGenerationMatches?: InputMaybe<Scalars['ID']>;
  media: Array<Scalars['ID']>;
};


export type MutationUpdateMediaWithLocationsArgs = {
  designId: Scalars['ID'];
  locations: Array<Scalars['String']>;
};


export type MutationUpdateOrientationArgs = {
  designId: Scalars['ID'];
  orientation?: InputMaybe<Orientation>;
};


export type MutationUpdateQuantityArgs = {
  destinationId: Scalars['ID'];
  quantity: Scalars['Int'];
};


export type MutationUpdateShippingChoiceArgs = {
  choice: ShippingChoice;
  destinationId: Scalars['ID'];
};


export type MutationUpdateVendorSaleCancellationArgs = {
  canceled: Scalars['Boolean'];
  saleId: Scalars['ID'];
};

export type NewDevice = {
  id: Scalars['ID'];
  metadata?: InputMaybe<Scalars['Hashmap']>;
  platform: Scalars['String'];
};

export type NewEvent = {
  designId?: InputMaybe<Scalars['ID']>;
  deviceId?: InputMaybe<Scalars['ID']>;
  eventName: Scalars['String'];
  metadata?: InputMaybe<Scalars['Hashmap']>;
  orderId?: InputMaybe<Scalars['ID']>;
};

export type NewOrder = {
  customerEmail: Scalars['String'];
  vendorSaleId?: InputMaybe<Scalars['ID']>;
};

export type NewOrderResponse = {
  __typename?: 'NewOrderResponse';
  order: Order;
  token: Scalars['String'];
};

export type NewSubscription = {
  designId?: InputMaybe<Scalars['ID']>;
  deviceId?: InputMaybe<Scalars['ID']>;
  eventName: Scalars['String'];
  metadata?: InputMaybe<Scalars['Hashmap']>;
  orderId?: InputMaybe<Scalars['ID']>;
  unsubscribeOn?: InputMaybe<Scalars['String']>;
};

export type NewVendorSale = {
  createdBy: Scalars['String'];
  customerEmail?: InputMaybe<Scalars['String']>;
  customerFirstName?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  externalOrderId: Scalars['ID'];
  metadata?: InputMaybe<Scalars['Hashmap']>;
  quantity: Scalars['Int'];
  shippingSpeed: Scalars['String'];
  vendorId: Scalars['ID'];
};

export type Order = {
  __typename?: 'Order';
  books?: Maybe<Array<Book>>;
  cancelledAt?: Maybe<Scalars['Time']>;
  cardVideoEncodeAttempts?: Maybe<Scalars['Int']>;
  cardVideoEncodeProgress?: Maybe<Scalars['Float']>;
  cardVideoEncodedConfig?: Maybe<VideoConfiguration>;
  cardVideoSHA256?: Maybe<Scalars['String']>;
  cardVideoURL?: Maybe<Scalars['String']>;
  cost?: Maybe<Pricing>;
  createdAt: Scalars['Time'];
  customer?: Maybe<Customer>;
  customerEmail: Scalars['String'];
  customerId?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  designs?: Maybe<Array<DesignWithDestinations>>;
  discountId?: Maybe<Scalars['ID']>;
  finalizedAt?: Maybe<Scalars['Time']>;
  finalizedBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  items?: Maybe<Array<PackageItem>>;
  loyaltyCode?: Maybe<Scalars['ID']>;
  manualGain?: Maybe<Scalars['Int']>;
  manualOrientation: Scalars['String'];
  name: Scalars['String'];
  notes?: Maybe<Array<OrderNote>>;
  packages?: Maybe<Array<Package>>;
  paidAt?: Maybe<Scalars['Time']>;
  paymentIntent?: Maybe<Payment>;
  payments?: Maybe<Array<Payment>>;
  reservedAt?: Maybe<Scalars['Time']>;
  reservedBy?: Maybe<Scalars['String']>;
  scheduledDeliveryDate?: Maybe<Scalars['Time']>;
  shareVideoEncodeAttempts?: Maybe<Scalars['Int']>;
  shareVideoEncodeProgress?: Maybe<Scalars['Float']>;
  shareVideoSHA256?: Maybe<Scalars['String']>;
  shareVideoThumbnailURL?: Maybe<Scalars['String']>;
  shareVideoURL?: Maybe<Scalars['String']>;
  shippingLabels?: Maybe<Array<ShippingLabel>>;
  shopify?: Maybe<ShopifyOrder>;
  state: OrderState;
  status: Scalars['String'];
  vendorSale?: Maybe<VendorSale>;
};

export type OrderFilters = {
  express?: InputMaybe<Scalars['Boolean']>;
  late?: InputMaybe<Scalars['Boolean']>;
  preorder?: InputMaybe<Scalars['Boolean']>;
  scheduled?: InputMaybe<Scalars['Boolean']>;
  shipped?: InputMaybe<Scalars['Boolean']>;
  shippedNoPickup?: InputMaybe<Scalars['Boolean']>;
  vendor?: InputMaybe<Scalars['Boolean']>;
};

export type OrderNote = {
  __typename?: 'OrderNote';
  content: Scalars['String'];
  createdAt: Scalars['Time'];
  createdBy: User;
  id: Scalars['String'];
};

export type OrderNoteInput = {
  content: Scalars['String'];
  createdAt: Scalars['Time'];
  createdBy: UserInput;
  id: Scalars['String'];
};

export type OrderResponse = {
  __typename?: 'OrderResponse';
  order: Order;
};

export enum OrderState {
  Archived = 'archived',
  Canceled = 'canceled',
  Completed = 'completed',
  Draft = 'draft',
  Paid = 'paid'
}

export enum Orientation {
  Horizontal = 'horizontal',
  Vertical = 'vertical'
}

export type Package = {
  __typename?: 'Package';
  address: Address;
  books?: Maybe<Array<Book>>;
  createdAt: Scalars['Time'];
  destinations?: Maybe<Array<Destination>>;
  id: Scalars['ID'];
  items?: Maybe<Array<PackageItem>>;
  orders?: Maybe<Array<Order>>;
  shippingLabels?: Maybe<Array<ShippingLabel>>;
  shippingServiceCode?: Maybe<Scalars['String']>;
  shippingSpeed?: Maybe<Scalars['String']>;
  size: Scalars['String'];
};

export type PackageItem = {
  __typename?: 'PackageItem';
  book?: Maybe<Book>;
  createdAt: Scalars['Time'];
  destination: Destination;
  id: Scalars['ID'];
  order: Order;
  sku: Scalars['String'];
  state: ItemFulfillmentState;
  type: Scalars['String'];
};

export type PaginatedOrders = {
  __typename?: 'PaginatedOrders';
  cursor: Scalars['String'];
  orders: Array<Order>;
};

export type Payment = {
  __typename?: 'Payment';
  amountInCents: Scalars['Int'];
  clientSecret?: Maybe<Scalars['String']>;
  createdAt: Scalars['Time'];
  currency: Currency;
  id: Scalars['ID'];
  lastAttemptAt?: Maybe<Scalars['Time']>;
  refunds?: Maybe<Array<Refund>>;
  state: PaymentState;
  stateUpdatedAt?: Maybe<Scalars['Time']>;
  stripeCustomerId: Scalars['String'];
  successAt?: Maybe<Scalars['Time']>;
};

export enum PaymentState {
  Canceled = 'canceled',
  Processing = 'processing',
  RequiresAction = 'requires_action',
  RequiresConfirmation = 'requires_confirmation',
  RequiresPaymentMethod = 'requires_payment_method',
  Succeeded = 'succeeded'
}

export type PreviewResponse = {
  __typename?: 'PreviewResponse';
  playlistURL?: Maybe<Scalars['String']>;
};

export type Pricing = {
  __typename?: 'Pricing';
  byDestination: Array<DestinationCosts>;
  total: Costs;
};

export type Product = {
  __typename?: 'Product';
  allowSale: Scalars['Boolean'];
  createdAt: Scalars['Time'];
  discount: Scalars['Boolean'];
  displayName: Scalars['String'];
  durationSec?: Maybe<Scalars['Int']>;
  formFactor?: Maybe<ProductFormFactor>;
  id: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  priceInCents: Scalars['Int'];
  quantityDC?: Maybe<Scalars['Int']>;
  sizeIn?: Maybe<Scalars['Int']>;
  taxable: Scalars['Boolean'];
  type: ProductType;
};

export enum ProductFormFactor {
  Rect = 'rect',
  Square = 'square'
}

export enum ProductType {
  Cover = 'cover',
  Extra = 'extra',
  Other = 'other',
  Player = 'player'
}

export type QrCode = {
  __typename?: 'QRCode';
  dataURL: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  customerOrders?: Maybe<Array<Order>>;
  design: Design;
  designPreview: PreviewResponse;
  designs: Array<Design>;
  me: Customer;
  order: ShopifyOrder;
  orderPreview: PreviewResponse;
  orderStatus: Order;
  orders: Array<ShopifyOrder>;
  ordersByStorefrontIds: Array<ShopifyOrder>;
  products: Array<Product>;
  shareVideo: ShareVideoResponse;
  shippingOptions: Array<ShippingOption>;
  stock: Stock;
  updateRequired?: Maybe<UpdateRequiredResponse>;
  vendorSales: Array<VendorSale>;
  vendorSalesDownloadUrl?: Maybe<DownloadResponse>;
};


export type QueryCustomerOrdersArgs = {
  customerId: Scalars['ID'];
};


export type QueryDesignArgs = {
  designId: Scalars['ID'];
};


export type QueryDesignPreviewArgs = {
  designId: Scalars['ID'];
};


export type QueryOrderArgs = {
  deviceId: Scalars['ID'];
  orderId: Scalars['ID'];
};


export type QueryOrderPreviewArgs = {
  orderId: Scalars['ID'];
};


export type QueryOrderStatusArgs = {
  orderId: Scalars['ID'];
};


export type QueryOrdersArgs = {
  deviceId: Scalars['ID'];
  orderIds: Array<Scalars['ID']>;
};


export type QueryOrdersByStorefrontIdsArgs = {
  deviceId: Scalars['ID'];
  storefrontIds: Array<Scalars['ID']>;
};


export type QueryShareVideoArgs = {
  deviceId: Scalars['ID'];
  orderId: Scalars['ID'];
};


export type QueryShippingOptionsArgs = {
  destinationId: Scalars['ID'];
};


export type QueryUpdateRequiredArgs = {
  currentVersion: Scalars['String'];
};


export type QueryVendorSalesArgs = {
  vendorId: Scalars['String'];
};


export type QueryVendorSalesDownloadUrlArgs = {
  vendorId: Scalars['String'];
};

export type Refund = {
  __typename?: 'Refund';
  amountInCents: Scalars['Int'];
  currency: Currency;
  date: Scalars['Time'];
  id: Scalars['ID'];
};

export type ReleaseResponse = {
  __typename?: 'ReleaseResponse';
  ordersReleased: Scalars['Int'];
};

export type Render = {
  __typename?: 'Render';
  encodeAttempts?: Maybe<Scalars['Int']>;
  encodeProgress?: Maybe<Scalars['Float']>;
  formFactor?: Maybe<ProductFormFactor>;
  gain: Scalars['Int'];
  id: Scalars['ID'];
  orientation: Scalars['String'];
  sha256?: Maybe<Scalars['String']>;
  signedURL?: Maybe<Scalars['String']>;
  task: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export enum Role {
  Admin = 'ADMIN',
  Customer = 'CUSTOMER',
  Partner = 'PARTNER'
}

export type ShareVideoResponse = {
  __typename?: 'ShareVideoResponse';
  shareVideoEncodeProgress?: Maybe<Scalars['Float']>;
  shareVideoSHA256?: Maybe<Scalars['String']>;
  shareVideoURL?: Maybe<Scalars['String']>;
};

export type Shipment = {
  __typename?: 'Shipment';
  shipment_id: Scalars['ID'];
};

export type ShippingCarrier = {
  __typename?: 'ShippingCarrier';
  carrier_code: Scalars['String'];
  carrier_id: Scalars['ID'];
  friendly_name: Scalars['String'];
  nickname: Scalars['String'];
};

export type ShippingChoice = {
  serviceCode?: InputMaybe<Scalars['String']>;
  shippingSpeed?: InputMaybe<Scalars['String']>;
};

export type ShippingCost = {
  __typename?: 'ShippingCost';
  amount: Scalars['Float'];
  currency: Scalars['String'];
};

export type ShippingLabel = {
  __typename?: 'ShippingLabel';
  actual_delivery_date?: Maybe<Scalars['String']>;
  batch_id?: Maybe<Scalars['ID']>;
  carrier_code: Scalars['String'];
  carrier_id: Scalars['ID'];
  carrier_tracking_status?: Maybe<Scalars['String']>;
  created_at: Scalars['String'];
  dest_country_code?: Maybe<Scalars['String']>;
  dest_postal_code?: Maybe<Scalars['String']>;
  dropoffs?: Maybe<Array<Dropoff>>;
  estimated_delivery_date?: Maybe<Scalars['String']>;
  events?: Maybe<Array<TrackingEvent>>;
  exception_description?: Maybe<Scalars['String']>;
  form_download?: Maybe<FormDownload>;
  fulfillment_id?: Maybe<Scalars['String']>;
  insurance_claim: Scalars['String'];
  insurance_cost?: Maybe<ShippingCost>;
  is_international: Scalars['Boolean'];
  is_return_label: Scalars['Boolean'];
  label_download?: Maybe<LabelDownload>;
  label_format: Scalars['String'];
  label_id: Scalars['ID'];
  label_layout: Scalars['String'];
  package_code: Scalars['String'];
  service_code: Scalars['String'];
  ship_date: Scalars['String'];
  shipment_cost?: Maybe<ShippingCost>;
  shipment_id: Scalars['String'];
  status: Scalars['String'];
  trackable: Scalars['Boolean'];
  tracking_number: Scalars['String'];
  tracking_status: Scalars['String'];
  tracking_updated_at?: Maybe<Scalars['String']>;
  voided: Scalars['Boolean'];
  voided_at?: Maybe<Scalars['String']>;
};

export type ShippingOption = {
  __typename?: 'ShippingOption';
  arrivalDate?: Maybe<Scalars['Time']>;
  cost: Cost;
  displayArrival?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  serviceCode?: Maybe<Scalars['String']>;
  shippingSpeed?: Maybe<Scalars['String']>;
};

export type ShippingRate = {
  __typename?: 'ShippingRate';
  carrier_code: Scalars['String'];
  carrier_delivery_days: Scalars['String'];
  carrier_friendly_name: Scalars['String'];
  carrier_id: Scalars['String'];
  carrier_nickname: Scalars['String'];
  confirmation_amount: ShippingCost;
  delivery_days: Scalars['Int'];
  error_messages?: Maybe<Array<Scalars['String']>>;
  estimated_delivery_date: Scalars['String'];
  guaranteed_service: Scalars['Boolean'];
  insurance_amount: ShippingCost;
  negotiated_rate: Scalars['Boolean'];
  other_amount: ShippingCost;
  package_type?: Maybe<Scalars['String']>;
  rate_id: Scalars['ID'];
  rate_type: Scalars['String'];
  saturday_delivery: Scalars['Boolean'];
  service_code: Scalars['String'];
  service_type: Scalars['String'];
  ship_date: Scalars['String'];
  shipping_amount: ShippingCost;
  tax_amount: ShippingCost;
  trackable: Scalars['Boolean'];
  validation_status: Scalars['String'];
  warning_messages?: Maybe<Array<Scalars['String']>>;
};

export type ShippingService = {
  __typename?: 'ShippingService';
  carrier_code: Scalars['String'];
  carrier_id: Scalars['ID'];
  domestic: Scalars['Boolean'];
  international: Scalars['Boolean'];
  name: Scalars['String'];
  service_code: Scalars['String'];
};

export type ShopifyAddress = {
  __typename?: 'ShopifyAddress';
  address1: Scalars['String'];
  address2: Scalars['String'];
  city: Scalars['String'];
  company: Scalars['String'];
  country: Scalars['String'];
  countryCode: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  name: Scalars['String'];
  phone: Scalars['String'];
  province: Scalars['String'];
  provinceCode: Scalars['String'];
  zip: Scalars['String'];
};

export type ShopifyFulfillment = {
  __typename?: 'ShopifyFulfillment';
  service: Scalars['String'];
  shipmentStatus: Scalars['String'];
  status: Scalars['String'];
  trackingCompany: Scalars['String'];
  trackingNumber: Scalars['String'];
  trackingNumbers?: Maybe<Array<Scalars['String']>>;
  trackingURL: Scalars['String'];
  trackingURLs?: Maybe<Array<Scalars['String']>>;
  updatedAt?: Maybe<Scalars['Time']>;
};

export type ShopifyImage = {
  __typename?: 'ShopifyImage';
  height: Scalars['Int'];
  id: Scalars['Int'];
  position: Scalars['Int'];
  src: Scalars['String'];
  width: Scalars['Int'];
};

export type ShopifyLineItem = {
  __typename?: 'ShopifyLineItem';
  SKU: Scalars['String'];
  fulfillmentStatus: Scalars['String'];
  giftCard: Scalars['Boolean'];
  name: Scalars['String'];
  preTaxPrice?: Maybe<Scalars['Float']>;
  price: Scalars['Float'];
  product?: Maybe<ShopifyProduct>;
  quantity: Scalars['Int'];
  taxable: Scalars['Boolean'];
  title: Scalars['String'];
  totalDiscount?: Maybe<Scalars['Float']>;
  variant?: Maybe<ShopifyVariant>;
  variantInventoryManagement: Scalars['String'];
  variantTitle: Scalars['String'];
  vendor: Scalars['String'];
};

export type ShopifyOrder = {
  __typename?: 'ShopifyOrder';
  billingAddress?: Maybe<ShopifyAddress>;
  cancelReason: Scalars['String'];
  cancelledAt?: Maybe<Scalars['Time']>;
  closedAt?: Maybe<Scalars['Time']>;
  createdAt?: Maybe<Scalars['Time']>;
  email: Scalars['String'];
  fulfillmentStatus: Scalars['String'];
  fulfillments?: Maybe<Array<ShopifyFulfillment>>;
  giftMessage: Scalars['String'];
  id: Scalars['Int'];
  lineItems?: Maybe<Array<ShopifyLineItem>>;
  name: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  processedAt?: Maybe<Scalars['Time']>;
  shipping?: Maybe<ShopifyShipping>;
  shippingAddress?: Maybe<ShopifyAddress>;
  test: Scalars['Boolean'];
  totalPrice?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Time']>;
  vendorSaleId?: Maybe<Scalars['String']>;
  videoManifest?: Maybe<Array<Scalars['String']>>;
  videoSHA256: Scalars['String'];
};

export type ShopifyOrderInput = {
  address: AddressInput;
  books: Array<BookLineItemInput>;
  email: Scalars['String'];
  giftMessage: Scalars['String'];
  videoManifest?: InputMaybe<Array<Scalars['String']>>;
};

export type ShopifyProduct = {
  __typename?: 'ShopifyProduct';
  bodyHTML: Scalars['String'];
  id: Scalars['Int'];
  image?: Maybe<ShopifyImage>;
  images?: Maybe<Array<ShopifyImage>>;
  productType: Scalars['String'];
  title: Scalars['String'];
};

export type ShopifyShipping = {
  __typename?: 'ShopifyShipping';
  carrierIdentifier: Scalars['String'];
  code: Scalars['String'];
  price: Scalars['String'];
  source: Scalars['String'];
  title: Scalars['String'];
};

export type ShopifyVariant = {
  __typename?: 'ShopifyVariant';
  SKU: Scalars['String'];
  id: Scalars['Int'];
  image?: Maybe<ShopifyImage>;
  price: Scalars['Float'];
  title: Scalars['String'];
};

export type SignedUrlResponse = {
  __typename?: 'SignedURLResponse';
  signedURL: Scalars['String'];
  unsignedURL: Scalars['String'];
};

export type SignedUrLsResponse = {
  __typename?: 'SignedURLsResponse';
  signedURLs: Array<Scalars['String']>;
};

export type Stock = {
  __typename?: 'Stock';
  books: Array<BookStockEntry>;
};

export type StockEntry = {
  __typename?: 'StockEntry';
  cost: Cost;
  description: Scalars['String'];
  displayName: Scalars['String'];
  id: Scalars['ID'];
  images?: Maybe<Array<Scalars['String']>>;
  quantity: Scalars['Int'];
};

export type TrackingEvent = {
  __typename?: 'TrackingEvent';
  city_locality?: Maybe<Scalars['String']>;
  country_code?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  event_code: Scalars['String'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  occurred_at: Scalars['String'];
  postal_code?: Maybe<Scalars['String']>;
  signer?: Maybe<Scalars['String']>;
  state_province?: Maybe<Scalars['String']>;
};

export type UpdatableCustomerProperties = {
  flagOrders?: InputMaybe<FlagInfoInput>;
};

export type UpdatableOrderProperties = {
  manualGain?: InputMaybe<Scalars['Int']>;
  manualOrientation?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Array<OrderNoteInput>>;
  scheduledDeliveryDate?: InputMaybe<Scalars['Time']>;
};

export enum UpdatePriority {
  Force = 'FORCE',
  Ignore = 'IGNORE',
  Notify = 'NOTIFY'
}

export type UpdateRequiredResponse = {
  __typename?: 'UpdateRequiredResponse';
  body: Scalars['String'];
  latestVersion: Scalars['String'];
  priority: UpdatePriority;
  title: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  email: Scalars['String'];
  name: Scalars['String'];
};

export type UserInput = {
  email: Scalars['String'];
  name: Scalars['String'];
};

/**
 * An vendor sale is when we sell one or more cards before they're actually
 * created as a Shopify order. Most commonly this would be us selling through
 * a third-party vendor like UncommonGoods.
 */
export type VendorSale = {
  __typename?: 'VendorSale';
  cancelledAt?: Maybe<Scalars['Time']>;
  couponCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['Time'];
  createdBy?: Maybe<Scalars['String']>;
  customerEmail: Scalars['String'];
  customerFirstName: Scalars['String'];
  deeplinkURL?: Maybe<Scalars['String']>;
  duration: Scalars['Int'];
  externalOrderId: Scalars['ID'];
  id: Scalars['ID'];
  orders?: Maybe<Array<Order>>;
  quantity: Scalars['Int'];
  shippingSpeed?: Maybe<Scalars['String']>;
  vendorId: Scalars['ID'];
};

export type VideoConfiguration = {
  __typename?: 'VideoConfiguration';
  allowVertical: Scalars['Boolean'];
  gain: Scalars['Int'];
  vertical: Scalars['Boolean'];
};

export type VideoRef = {
  __typename?: 'VideoRef';
  SHA256: Scalars['String'];
  URL: Scalars['String'];
};

export type VoidResponse = {
  __typename?: 'VoidResponse';
  approved: Scalars['Boolean'];
};

export enum WarehouseCode {
  Dc = 'DC',
  Tx = 'TX'
}

export type AddDesignMutationVariables = Exact<{
  orderId: Scalars['ID'];
  cloneDesignId?: InputMaybe<Scalars['ID']>;
}>;


export type AddDesignMutation = { __typename?: 'Mutation', addDesign: { __typename?: 'DesignResponse', order?: { __typename?: 'Order', id: string, state: OrderState, createdAt: any, paidAt?: any | null | undefined, finalizedAt?: any | null | undefined, cancelledAt?: any | null | undefined, discountId?: string | null | undefined, cost?: { __typename?: 'Pricing', total: { __typename?: 'Costs', product: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, shipping: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, tax: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, total: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, balanceUsed: { __typename?: 'CustomerBalance', cashInCents: number, products: Array<{ __typename?: 'CustomerBalanceProduct', quantity: number, product: { __typename?: 'Product', id: string, createdAt: any, displayName: string, type: ProductType, sizeIn?: number | null | undefined, formFactor?: ProductFormFactor | null | undefined, durationSec?: number | null | undefined, image?: string | null | undefined, allowSale: boolean, priceInCents: number }, entries: Array<{ __typename?: 'BalanceEntry', id: string, createdAt: any, originalCashInCents: number, cashRemainingInCents: number, vendorDisplayName: string, products: Array<{ __typename?: 'BalanceEntryProduct', productId: string, originalQuantity: number, quantityRemaining: number }> }> }> } }, byDestination: Array<{ __typename?: 'DestinationCosts', destinationId: string, costs: { __typename?: 'Costs', product: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, shipping: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, tax: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, total: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, balanceUsed: { __typename?: 'CustomerBalance', cashInCents: number, products: Array<{ __typename?: 'CustomerBalanceProduct', quantity: number, product: { __typename?: 'Product', id: string, createdAt: any, displayName: string, type: ProductType, sizeIn?: number | null | undefined, formFactor?: ProductFormFactor | null | undefined, durationSec?: number | null | undefined, image?: string | null | undefined, allowSale: boolean, priceInCents: number }, entries: Array<{ __typename?: 'BalanceEntry', id: string, createdAt: any, originalCashInCents: number, cashRemainingInCents: number, vendorDisplayName: string, products: Array<{ __typename?: 'BalanceEntryProduct', productId: string, originalQuantity: number, quantityRemaining: number }> }> }> } } }> } | null | undefined, designs?: Array<{ __typename?: 'DesignWithDestinations', design?: { __typename?: 'Design', id: string, createdAt: any, durationSeconds: number, generation: string, media?: Array<{ __typename?: 'MediaEntry', id: string, type?: string | null | undefined, encodedLocation: string, signedEncodedLocation?: string | null | undefined, signedThumbnailLocation?: string | null | undefined, signedVideoThumbnailLocation?: string | null | undefined, signedPosterLocation?: string | null | undefined, encodeProgress: number, format?: string | null | undefined, durationSeconds?: number | null | undefined, backgroundVolume: number, mediaVolume: number, clips: Array<{ __typename?: 'Clip', startMs: number, endMs: number, rotation: number }> }> | null | undefined, renders?: Array<{ __typename?: 'Render', id: string, formFactor?: ProductFormFactor | null | undefined, task: string, gain: number, orientation: string, url?: string | null | undefined, signedURL?: string | null | undefined, encodeProgress?: number | null | undefined, encodeAttempts?: number | null | undefined }> | null | undefined } | null | undefined, destinations?: Array<{ __typename?: 'Destination', id: string, designId: string, state: string, coverId?: string | null | undefined, quantity: number, shippingSpeed?: string | null | undefined, shippingServiceCode?: string | null | undefined, giftMessage?: { __typename?: 'Message', body: string } | null | undefined, extras?: Array<{ __typename?: 'Extra', id: string }> | null | undefined, address?: { __typename?: 'Address', fullName: string, companyName?: string | null | undefined, street1: string, street2?: string | null | undefined, cityLocality: string, countryCode: string, stateProvinceCode: string, postalCode: string, phoneNumber?: string | null | undefined, nickname?: string | null | undefined } | null | undefined }> | null | undefined }> | null | undefined } | null | undefined, design: { __typename?: 'Design', id: string, createdAt: any, durationSeconds: number, generation: string, media?: Array<{ __typename?: 'MediaEntry', id: string, type?: string | null | undefined, encodedLocation: string, signedEncodedLocation?: string | null | undefined, signedThumbnailLocation?: string | null | undefined, signedVideoThumbnailLocation?: string | null | undefined, signedPosterLocation?: string | null | undefined, encodeProgress: number, format?: string | null | undefined, durationSeconds?: number | null | undefined, backgroundVolume: number, mediaVolume: number, clips: Array<{ __typename?: 'Clip', startMs: number, endMs: number, rotation: number }> }> | null | undefined, renders?: Array<{ __typename?: 'Render', id: string, formFactor?: ProductFormFactor | null | undefined, task: string, gain: number, orientation: string, url?: string | null | undefined, signedURL?: string | null | undefined, encodeProgress?: number | null | undefined, encodeAttempts?: number | null | undefined }> | null | undefined } } };

export type AddDestinationMutationVariables = Exact<{
  orderId: Scalars['ID'];
  designId: Scalars['ID'];
  cloneDestinationId?: InputMaybe<Scalars['ID']>;
}>;


export type AddDestinationMutation = { __typename?: 'Mutation', addDestination: { __typename?: 'Order', id: string, state: OrderState, createdAt: any, paidAt?: any | null | undefined, finalizedAt?: any | null | undefined, cancelledAt?: any | null | undefined, discountId?: string | null | undefined, cost?: { __typename?: 'Pricing', total: { __typename?: 'Costs', product: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, shipping: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, tax: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, total: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, balanceUsed: { __typename?: 'CustomerBalance', cashInCents: number, products: Array<{ __typename?: 'CustomerBalanceProduct', quantity: number, product: { __typename?: 'Product', id: string, createdAt: any, displayName: string, type: ProductType, sizeIn?: number | null | undefined, formFactor?: ProductFormFactor | null | undefined, durationSec?: number | null | undefined, image?: string | null | undefined, allowSale: boolean, priceInCents: number }, entries: Array<{ __typename?: 'BalanceEntry', id: string, createdAt: any, originalCashInCents: number, cashRemainingInCents: number, vendorDisplayName: string, products: Array<{ __typename?: 'BalanceEntryProduct', productId: string, originalQuantity: number, quantityRemaining: number }> }> }> } }, byDestination: Array<{ __typename?: 'DestinationCosts', destinationId: string, costs: { __typename?: 'Costs', product: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, shipping: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, tax: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, total: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, balanceUsed: { __typename?: 'CustomerBalance', cashInCents: number, products: Array<{ __typename?: 'CustomerBalanceProduct', quantity: number, product: { __typename?: 'Product', id: string, createdAt: any, displayName: string, type: ProductType, sizeIn?: number | null | undefined, formFactor?: ProductFormFactor | null | undefined, durationSec?: number | null | undefined, image?: string | null | undefined, allowSale: boolean, priceInCents: number }, entries: Array<{ __typename?: 'BalanceEntry', id: string, createdAt: any, originalCashInCents: number, cashRemainingInCents: number, vendorDisplayName: string, products: Array<{ __typename?: 'BalanceEntryProduct', productId: string, originalQuantity: number, quantityRemaining: number }> }> }> } } }> } | null | undefined, designs?: Array<{ __typename?: 'DesignWithDestinations', design?: { __typename?: 'Design', id: string, createdAt: any, durationSeconds: number, generation: string, media?: Array<{ __typename?: 'MediaEntry', id: string, type?: string | null | undefined, encodedLocation: string, signedEncodedLocation?: string | null | undefined, signedThumbnailLocation?: string | null | undefined, signedVideoThumbnailLocation?: string | null | undefined, signedPosterLocation?: string | null | undefined, encodeProgress: number, format?: string | null | undefined, durationSeconds?: number | null | undefined, backgroundVolume: number, mediaVolume: number, clips: Array<{ __typename?: 'Clip', startMs: number, endMs: number, rotation: number }> }> | null | undefined, renders?: Array<{ __typename?: 'Render', id: string, formFactor?: ProductFormFactor | null | undefined, task: string, gain: number, orientation: string, url?: string | null | undefined, signedURL?: string | null | undefined, encodeProgress?: number | null | undefined, encodeAttempts?: number | null | undefined }> | null | undefined } | null | undefined, destinations?: Array<{ __typename?: 'Destination', id: string, designId: string, state: string, coverId?: string | null | undefined, quantity: number, shippingSpeed?: string | null | undefined, shippingServiceCode?: string | null | undefined, giftMessage?: { __typename?: 'Message', body: string } | null | undefined, extras?: Array<{ __typename?: 'Extra', id: string }> | null | undefined, address?: { __typename?: 'Address', fullName: string, companyName?: string | null | undefined, street1: string, street2?: string | null | undefined, cityLocality: string, countryCode: string, stateProvinceCode: string, postalCode: string, phoneNumber?: string | null | undefined, nickname?: string | null | undefined } | null | undefined }> | null | undefined }> | null | undefined } };

export type AddExtraMutationVariables = Exact<{
  destinationId: Scalars['ID'];
  extra: ExtraInput;
}>;


export type AddExtraMutation = { __typename?: 'Mutation', addExtra: { __typename?: 'Order', id: string, state: OrderState, createdAt: any, paidAt?: any | null | undefined, finalizedAt?: any | null | undefined, cancelledAt?: any | null | undefined, discountId?: string | null | undefined, cost?: { __typename?: 'Pricing', total: { __typename?: 'Costs', product: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, shipping: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, tax: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, total: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, balanceUsed: { __typename?: 'CustomerBalance', cashInCents: number, products: Array<{ __typename?: 'CustomerBalanceProduct', quantity: number, product: { __typename?: 'Product', id: string, createdAt: any, displayName: string, type: ProductType, sizeIn?: number | null | undefined, formFactor?: ProductFormFactor | null | undefined, durationSec?: number | null | undefined, image?: string | null | undefined, allowSale: boolean, priceInCents: number }, entries: Array<{ __typename?: 'BalanceEntry', id: string, createdAt: any, originalCashInCents: number, cashRemainingInCents: number, vendorDisplayName: string, products: Array<{ __typename?: 'BalanceEntryProduct', productId: string, originalQuantity: number, quantityRemaining: number }> }> }> } }, byDestination: Array<{ __typename?: 'DestinationCosts', destinationId: string, costs: { __typename?: 'Costs', product: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, shipping: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, tax: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, total: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, balanceUsed: { __typename?: 'CustomerBalance', cashInCents: number, products: Array<{ __typename?: 'CustomerBalanceProduct', quantity: number, product: { __typename?: 'Product', id: string, createdAt: any, displayName: string, type: ProductType, sizeIn?: number | null | undefined, formFactor?: ProductFormFactor | null | undefined, durationSec?: number | null | undefined, image?: string | null | undefined, allowSale: boolean, priceInCents: number }, entries: Array<{ __typename?: 'BalanceEntry', id: string, createdAt: any, originalCashInCents: number, cashRemainingInCents: number, vendorDisplayName: string, products: Array<{ __typename?: 'BalanceEntryProduct', productId: string, originalQuantity: number, quantityRemaining: number }> }> }> } } }> } | null | undefined, designs?: Array<{ __typename?: 'DesignWithDestinations', design?: { __typename?: 'Design', id: string, createdAt: any, durationSeconds: number, generation: string, media?: Array<{ __typename?: 'MediaEntry', id: string, type?: string | null | undefined, encodedLocation: string, signedEncodedLocation?: string | null | undefined, signedThumbnailLocation?: string | null | undefined, signedVideoThumbnailLocation?: string | null | undefined, signedPosterLocation?: string | null | undefined, encodeProgress: number, format?: string | null | undefined, durationSeconds?: number | null | undefined, backgroundVolume: number, mediaVolume: number, clips: Array<{ __typename?: 'Clip', startMs: number, endMs: number, rotation: number }> }> | null | undefined, renders?: Array<{ __typename?: 'Render', id: string, formFactor?: ProductFormFactor | null | undefined, task: string, gain: number, orientation: string, url?: string | null | undefined, signedURL?: string | null | undefined, encodeProgress?: number | null | undefined, encodeAttempts?: number | null | undefined }> | null | undefined } | null | undefined, destinations?: Array<{ __typename?: 'Destination', id: string, designId: string, state: string, coverId?: string | null | undefined, quantity: number, shippingSpeed?: string | null | undefined, shippingServiceCode?: string | null | undefined, giftMessage?: { __typename?: 'Message', body: string } | null | undefined, extras?: Array<{ __typename?: 'Extra', id: string }> | null | undefined, address?: { __typename?: 'Address', fullName: string, companyName?: string | null | undefined, street1: string, street2?: string | null | undefined, cityLocality: string, countryCode: string, stateProvinceCode: string, postalCode: string, phoneNumber?: string | null | undefined, nickname?: string | null | undefined } | null | undefined }> | null | undefined }> | null | undefined } };

export type AppendMediaMutationVariables = Exact<{
  designID: Scalars['ID'];
  media: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type AppendMediaMutation = { __typename?: 'Mutation', appendMedia: { __typename?: 'Design', id: string, createdAt: any, durationSeconds: number, generation: string, media?: Array<{ __typename?: 'MediaEntry', id: string, type?: string | null | undefined, encodedLocation: string, signedEncodedLocation?: string | null | undefined, signedThumbnailLocation?: string | null | undefined, signedVideoThumbnailLocation?: string | null | undefined, signedPosterLocation?: string | null | undefined, encodeProgress: number, format?: string | null | undefined, durationSeconds?: number | null | undefined, backgroundVolume: number, mediaVolume: number, clips: Array<{ __typename?: 'Clip', startMs: number, endMs: number, rotation: number }> }> | null | undefined, renders?: Array<{ __typename?: 'Render', id: string, formFactor?: ProductFormFactor | null | undefined, task: string, gain: number, orientation: string, url?: string | null | undefined, signedURL?: string | null | undefined, encodeProgress?: number | null | undefined, encodeAttempts?: number | null | undefined }> | null | undefined } };

export type ApplyDiscountCodeMutationVariables = Exact<{
  orderId: Scalars['ID'];
  discountId: Scalars['String'];
}>;


export type ApplyDiscountCodeMutation = { __typename?: 'Mutation', applyDiscountCode: { __typename?: 'Order', id: string, state: OrderState, createdAt: any, paidAt?: any | null | undefined, finalizedAt?: any | null | undefined, cancelledAt?: any | null | undefined, discountId?: string | null | undefined, cost?: { __typename?: 'Pricing', total: { __typename?: 'Costs', product: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, shipping: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, tax: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, total: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, balanceUsed: { __typename?: 'CustomerBalance', cashInCents: number, products: Array<{ __typename?: 'CustomerBalanceProduct', quantity: number, product: { __typename?: 'Product', id: string, createdAt: any, displayName: string, type: ProductType, sizeIn?: number | null | undefined, formFactor?: ProductFormFactor | null | undefined, durationSec?: number | null | undefined, image?: string | null | undefined, allowSale: boolean, priceInCents: number }, entries: Array<{ __typename?: 'BalanceEntry', id: string, createdAt: any, originalCashInCents: number, cashRemainingInCents: number, vendorDisplayName: string, products: Array<{ __typename?: 'BalanceEntryProduct', productId: string, originalQuantity: number, quantityRemaining: number }> }> }> } }, byDestination: Array<{ __typename?: 'DestinationCosts', destinationId: string, costs: { __typename?: 'Costs', product: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, shipping: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, tax: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, total: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, balanceUsed: { __typename?: 'CustomerBalance', cashInCents: number, products: Array<{ __typename?: 'CustomerBalanceProduct', quantity: number, product: { __typename?: 'Product', id: string, createdAt: any, displayName: string, type: ProductType, sizeIn?: number | null | undefined, formFactor?: ProductFormFactor | null | undefined, durationSec?: number | null | undefined, image?: string | null | undefined, allowSale: boolean, priceInCents: number }, entries: Array<{ __typename?: 'BalanceEntry', id: string, createdAt: any, originalCashInCents: number, cashRemainingInCents: number, vendorDisplayName: string, products: Array<{ __typename?: 'BalanceEntryProduct', productId: string, originalQuantity: number, quantityRemaining: number }> }> }> } } }> } | null | undefined, designs?: Array<{ __typename?: 'DesignWithDestinations', design?: { __typename?: 'Design', id: string, createdAt: any, durationSeconds: number, generation: string, media?: Array<{ __typename?: 'MediaEntry', id: string, type?: string | null | undefined, encodedLocation: string, signedEncodedLocation?: string | null | undefined, signedThumbnailLocation?: string | null | undefined, signedVideoThumbnailLocation?: string | null | undefined, signedPosterLocation?: string | null | undefined, encodeProgress: number, format?: string | null | undefined, durationSeconds?: number | null | undefined, backgroundVolume: number, mediaVolume: number, clips: Array<{ __typename?: 'Clip', startMs: number, endMs: number, rotation: number }> }> | null | undefined, renders?: Array<{ __typename?: 'Render', id: string, formFactor?: ProductFormFactor | null | undefined, task: string, gain: number, orientation: string, url?: string | null | undefined, signedURL?: string | null | undefined, encodeProgress?: number | null | undefined, encodeAttempts?: number | null | undefined }> | null | undefined } | null | undefined, destinations?: Array<{ __typename?: 'Destination', id: string, designId: string, state: string, coverId?: string | null | undefined, quantity: number, shippingSpeed?: string | null | undefined, shippingServiceCode?: string | null | undefined, giftMessage?: { __typename?: 'Message', body: string } | null | undefined, extras?: Array<{ __typename?: 'Extra', id: string }> | null | undefined, address?: { __typename?: 'Address', fullName: string, companyName?: string | null | undefined, street1: string, street2?: string | null | undefined, cityLocality: string, countryCode: string, stateProvinceCode: string, postalCode: string, phoneNumber?: string | null | undefined, nickname?: string | null | undefined } | null | undefined }> | null | undefined }> | null | undefined } };

export type CreateDraftOrderMutationVariables = Exact<{
  order: NewOrder;
}>;


export type CreateDraftOrderMutation = { __typename?: 'Mutation', createDraftOrder: { __typename?: 'NewOrderResponse', order: { __typename?: 'Order', id: string, designs?: Array<{ __typename?: 'DesignWithDestinations', design?: { __typename?: 'Design', id: string } | null | undefined }> | null | undefined } } };

export type DesignQueryVariables = Exact<{
  designId: Scalars['ID'];
}>;


export type DesignQuery = { __typename?: 'Query', design: { __typename?: 'Design', id: string, createdAt: any, durationSeconds: number, generation: string, media?: Array<{ __typename?: 'MediaEntry', id: string, type?: string | null | undefined, encodedLocation: string, signedEncodedLocation?: string | null | undefined, signedThumbnailLocation?: string | null | undefined, signedVideoThumbnailLocation?: string | null | undefined, signedPosterLocation?: string | null | undefined, encodeProgress: number, format?: string | null | undefined, durationSeconds?: number | null | undefined, backgroundVolume: number, mediaVolume: number, clips: Array<{ __typename?: 'Clip', startMs: number, endMs: number, rotation: number }> }> | null | undefined, renders?: Array<{ __typename?: 'Render', id: string, formFactor?: ProductFormFactor | null | undefined, task: string, gain: number, orientation: string, url?: string | null | undefined, signedURL?: string | null | undefined, encodeProgress?: number | null | undefined, encodeAttempts?: number | null | undefined }> | null | undefined } };

export type DesignsQueryVariables = Exact<{ [key: string]: never; }>;


export type DesignsQuery = { __typename?: 'Query', designs: Array<{ __typename?: 'Design', id: string, createdAt: any, durationSeconds: number, generation: string, media?: Array<{ __typename?: 'MediaEntry', id: string, type?: string | null | undefined, encodedLocation: string, signedEncodedLocation?: string | null | undefined, signedThumbnailLocation?: string | null | undefined, signedVideoThumbnailLocation?: string | null | undefined, signedPosterLocation?: string | null | undefined, encodeProgress: number, format?: string | null | undefined, durationSeconds?: number | null | undefined, backgroundVolume: number, mediaVolume: number, clips: Array<{ __typename?: 'Clip', startMs: number, endMs: number, rotation: number }> }> | null | undefined, renders?: Array<{ __typename?: 'Render', id: string, formFactor?: ProductFormFactor | null | undefined, task: string, gain: number, orientation: string, url?: string | null | undefined, signedURL?: string | null | undefined, encodeProgress?: number | null | undefined, encodeAttempts?: number | null | undefined }> | null | undefined }> };

export type EditMediaMutationVariables = Exact<{
  designId: Scalars['ID'];
  mediaEntryId: Scalars['ID'];
  media: MediaEntryEdit;
}>;


export type EditMediaMutation = { __typename?: 'Mutation', editMedia: { __typename?: 'Design', id: string, createdAt: any, durationSeconds: number, generation: string, media?: Array<{ __typename?: 'MediaEntry', id: string, type?: string | null | undefined, encodedLocation: string, signedEncodedLocation?: string | null | undefined, signedThumbnailLocation?: string | null | undefined, signedVideoThumbnailLocation?: string | null | undefined, signedPosterLocation?: string | null | undefined, encodeProgress: number, format?: string | null | undefined, durationSeconds?: number | null | undefined, backgroundVolume: number, mediaVolume: number, clips: Array<{ __typename?: 'Clip', startMs: number, endMs: number, rotation: number }> }> | null | undefined, renders?: Array<{ __typename?: 'Render', id: string, formFactor?: ProductFormFactor | null | undefined, task: string, gain: number, orientation: string, url?: string | null | undefined, signedURL?: string | null | undefined, encodeProgress?: number | null | undefined, encodeAttempts?: number | null | undefined }> | null | undefined } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'Customer', id: string, createdAt: any, email: string, balance?: { __typename?: 'CustomerBalance', cashInCents: number, products: Array<{ __typename?: 'CustomerBalanceProduct', quantity: number, product: { __typename?: 'Product', id: string, createdAt: any, displayName: string, type: ProductType, sizeIn?: number | null | undefined, formFactor?: ProductFormFactor | null | undefined, durationSec?: number | null | undefined, image?: string | null | undefined, allowSale: boolean, priceInCents: number }, entries: Array<{ __typename?: 'BalanceEntry', id: string, createdAt: any, originalCashInCents: number, cashRemainingInCents: number, vendorDisplayName: string, products: Array<{ __typename?: 'BalanceEntryProduct', productId: string, originalQuantity: number, quantityRemaining: number }> }> }> } | null | undefined } };

export type OrderQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type OrderQuery = { __typename?: 'Query', orderStatus: { __typename?: 'Order', id: string, state: OrderState, createdAt: any, paidAt?: any | null | undefined, finalizedAt?: any | null | undefined, cancelledAt?: any | null | undefined, discountId?: string | null | undefined, cost?: { __typename?: 'Pricing', total: { __typename?: 'Costs', product: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, shipping: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, tax: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, total: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, balanceUsed: { __typename?: 'CustomerBalance', cashInCents: number, products: Array<{ __typename?: 'CustomerBalanceProduct', quantity: number, product: { __typename?: 'Product', id: string, createdAt: any, displayName: string, type: ProductType, sizeIn?: number | null | undefined, formFactor?: ProductFormFactor | null | undefined, durationSec?: number | null | undefined, image?: string | null | undefined, allowSale: boolean, priceInCents: number }, entries: Array<{ __typename?: 'BalanceEntry', id: string, createdAt: any, originalCashInCents: number, cashRemainingInCents: number, vendorDisplayName: string, products: Array<{ __typename?: 'BalanceEntryProduct', productId: string, originalQuantity: number, quantityRemaining: number }> }> }> } }, byDestination: Array<{ __typename?: 'DestinationCosts', destinationId: string, costs: { __typename?: 'Costs', product: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, shipping: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, tax: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, total: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, balanceUsed: { __typename?: 'CustomerBalance', cashInCents: number, products: Array<{ __typename?: 'CustomerBalanceProduct', quantity: number, product: { __typename?: 'Product', id: string, createdAt: any, displayName: string, type: ProductType, sizeIn?: number | null | undefined, formFactor?: ProductFormFactor | null | undefined, durationSec?: number | null | undefined, image?: string | null | undefined, allowSale: boolean, priceInCents: number }, entries: Array<{ __typename?: 'BalanceEntry', id: string, createdAt: any, originalCashInCents: number, cashRemainingInCents: number, vendorDisplayName: string, products: Array<{ __typename?: 'BalanceEntryProduct', productId: string, originalQuantity: number, quantityRemaining: number }> }> }> } } }> } | null | undefined, designs?: Array<{ __typename?: 'DesignWithDestinations', design?: { __typename?: 'Design', id: string, createdAt: any, durationSeconds: number, generation: string, media?: Array<{ __typename?: 'MediaEntry', id: string, type?: string | null | undefined, encodedLocation: string, signedEncodedLocation?: string | null | undefined, signedThumbnailLocation?: string | null | undefined, signedVideoThumbnailLocation?: string | null | undefined, signedPosterLocation?: string | null | undefined, encodeProgress: number, format?: string | null | undefined, durationSeconds?: number | null | undefined, backgroundVolume: number, mediaVolume: number, clips: Array<{ __typename?: 'Clip', startMs: number, endMs: number, rotation: number }> }> | null | undefined, renders?: Array<{ __typename?: 'Render', id: string, formFactor?: ProductFormFactor | null | undefined, task: string, gain: number, orientation: string, url?: string | null | undefined, signedURL?: string | null | undefined, encodeProgress?: number | null | undefined, encodeAttempts?: number | null | undefined }> | null | undefined } | null | undefined, destinations?: Array<{ __typename?: 'Destination', id: string, designId: string, state: string, coverId?: string | null | undefined, quantity: number, shippingSpeed?: string | null | undefined, shippingServiceCode?: string | null | undefined, giftMessage?: { __typename?: 'Message', body: string } | null | undefined, extras?: Array<{ __typename?: 'Extra', id: string }> | null | undefined, address?: { __typename?: 'Address', fullName: string, companyName?: string | null | undefined, street1: string, street2?: string | null | undefined, cityLocality: string, countryCode: string, stateProvinceCode: string, postalCode: string, phoneNumber?: string | null | undefined, nickname?: string | null | undefined } | null | undefined }> | null | undefined }> | null | undefined }, stock: { __typename?: 'Stock', books: Array<{ __typename?: 'BookStockEntry', id: string, durations: Array<{ __typename?: 'DurationStockEntry', id: string, displayName: string, ifLessThanDurationSec: number, quantity: number }>, covers: Array<{ __typename?: 'StockEntry', id: string, displayName: string, images?: Array<string> | null | undefined, quantity: number }>, extras: Array<{ __typename?: 'StockEntry', id: string, displayName: string, images?: Array<string> | null | undefined, quantity: number }> }> } };

export type OrderForPaymentQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type OrderForPaymentQuery = { __typename?: 'Query', orderStatus: { __typename?: 'Order', id: string, paymentIntent?: { __typename?: 'Payment', id: string, amountInCents: number, clientSecret?: string | null | undefined } | null | undefined } };

export type OrdersQueryVariables = Exact<{
  customerId: Scalars['ID'];
}>;


export type OrdersQuery = { __typename?: 'Query', customerOrders?: Array<{ __typename?: 'Order', id: string, state: OrderState, createdAt: any, paidAt?: any | null | undefined, finalizedAt?: any | null | undefined, cancelledAt?: any | null | undefined, discountId?: string | null | undefined, cost?: { __typename?: 'Pricing', total: { __typename?: 'Costs', product: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, shipping: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, tax: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, total: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, balanceUsed: { __typename?: 'CustomerBalance', cashInCents: number, products: Array<{ __typename?: 'CustomerBalanceProduct', quantity: number, product: { __typename?: 'Product', id: string, createdAt: any, displayName: string, type: ProductType, sizeIn?: number | null | undefined, formFactor?: ProductFormFactor | null | undefined, durationSec?: number | null | undefined, image?: string | null | undefined, allowSale: boolean, priceInCents: number }, entries: Array<{ __typename?: 'BalanceEntry', id: string, createdAt: any, originalCashInCents: number, cashRemainingInCents: number, vendorDisplayName: string, products: Array<{ __typename?: 'BalanceEntryProduct', productId: string, originalQuantity: number, quantityRemaining: number }> }> }> } }, byDestination: Array<{ __typename?: 'DestinationCosts', destinationId: string, costs: { __typename?: 'Costs', product: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, shipping: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, tax: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, total: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, balanceUsed: { __typename?: 'CustomerBalance', cashInCents: number, products: Array<{ __typename?: 'CustomerBalanceProduct', quantity: number, product: { __typename?: 'Product', id: string, createdAt: any, displayName: string, type: ProductType, sizeIn?: number | null | undefined, formFactor?: ProductFormFactor | null | undefined, durationSec?: number | null | undefined, image?: string | null | undefined, allowSale: boolean, priceInCents: number }, entries: Array<{ __typename?: 'BalanceEntry', id: string, createdAt: any, originalCashInCents: number, cashRemainingInCents: number, vendorDisplayName: string, products: Array<{ __typename?: 'BalanceEntryProduct', productId: string, originalQuantity: number, quantityRemaining: number }> }> }> } } }> } | null | undefined, designs?: Array<{ __typename?: 'DesignWithDestinations', design?: { __typename?: 'Design', id: string, createdAt: any, durationSeconds: number, generation: string, media?: Array<{ __typename?: 'MediaEntry', id: string, type?: string | null | undefined, encodedLocation: string, signedEncodedLocation?: string | null | undefined, signedThumbnailLocation?: string | null | undefined, signedVideoThumbnailLocation?: string | null | undefined, signedPosterLocation?: string | null | undefined, encodeProgress: number, format?: string | null | undefined, durationSeconds?: number | null | undefined, backgroundVolume: number, mediaVolume: number, clips: Array<{ __typename?: 'Clip', startMs: number, endMs: number, rotation: number }> }> | null | undefined, renders?: Array<{ __typename?: 'Render', id: string, formFactor?: ProductFormFactor | null | undefined, task: string, gain: number, orientation: string, url?: string | null | undefined, signedURL?: string | null | undefined, encodeProgress?: number | null | undefined, encodeAttempts?: number | null | undefined }> | null | undefined } | null | undefined, destinations?: Array<{ __typename?: 'Destination', id: string, designId: string, state: string, coverId?: string | null | undefined, quantity: number, shippingSpeed?: string | null | undefined, shippingServiceCode?: string | null | undefined, giftMessage?: { __typename?: 'Message', body: string } | null | undefined, extras?: Array<{ __typename?: 'Extra', id: string }> | null | undefined, address?: { __typename?: 'Address', fullName: string, companyName?: string | null | undefined, street1: string, street2?: string | null | undefined, cityLocality: string, countryCode: string, stateProvinceCode: string, postalCode: string, phoneNumber?: string | null | undefined, nickname?: string | null | undefined } | null | undefined }> | null | undefined }> | null | undefined }> | null | undefined };

export type PreviewQueryVariables = Exact<{
  designId: Scalars['ID'];
}>;


export type PreviewQuery = { __typename?: 'Query', designPreview: { __typename?: 'PreviewResponse', playlistURL?: string | null | undefined } };

export type RemoveDestinationMutationVariables = Exact<{
  orderId: Scalars['ID'];
  designId: Scalars['ID'];
  destinationId: Scalars['ID'];
}>;


export type RemoveDestinationMutation = { __typename?: 'Mutation', removeDestination: { __typename?: 'Order', id: string, state: OrderState, createdAt: any, paidAt?: any | null | undefined, finalizedAt?: any | null | undefined, cancelledAt?: any | null | undefined, discountId?: string | null | undefined, cost?: { __typename?: 'Pricing', total: { __typename?: 'Costs', product: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, shipping: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, tax: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, total: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, balanceUsed: { __typename?: 'CustomerBalance', cashInCents: number, products: Array<{ __typename?: 'CustomerBalanceProduct', quantity: number, product: { __typename?: 'Product', id: string, createdAt: any, displayName: string, type: ProductType, sizeIn?: number | null | undefined, formFactor?: ProductFormFactor | null | undefined, durationSec?: number | null | undefined, image?: string | null | undefined, allowSale: boolean, priceInCents: number }, entries: Array<{ __typename?: 'BalanceEntry', id: string, createdAt: any, originalCashInCents: number, cashRemainingInCents: number, vendorDisplayName: string, products: Array<{ __typename?: 'BalanceEntryProduct', productId: string, originalQuantity: number, quantityRemaining: number }> }> }> } }, byDestination: Array<{ __typename?: 'DestinationCosts', destinationId: string, costs: { __typename?: 'Costs', product: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, shipping: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, tax: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, total: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, balanceUsed: { __typename?: 'CustomerBalance', cashInCents: number, products: Array<{ __typename?: 'CustomerBalanceProduct', quantity: number, product: { __typename?: 'Product', id: string, createdAt: any, displayName: string, type: ProductType, sizeIn?: number | null | undefined, formFactor?: ProductFormFactor | null | undefined, durationSec?: number | null | undefined, image?: string | null | undefined, allowSale: boolean, priceInCents: number }, entries: Array<{ __typename?: 'BalanceEntry', id: string, createdAt: any, originalCashInCents: number, cashRemainingInCents: number, vendorDisplayName: string, products: Array<{ __typename?: 'BalanceEntryProduct', productId: string, originalQuantity: number, quantityRemaining: number }> }> }> } } }> } | null | undefined, designs?: Array<{ __typename?: 'DesignWithDestinations', design?: { __typename?: 'Design', id: string, createdAt: any, durationSeconds: number, generation: string, media?: Array<{ __typename?: 'MediaEntry', id: string, type?: string | null | undefined, encodedLocation: string, signedEncodedLocation?: string | null | undefined, signedThumbnailLocation?: string | null | undefined, signedVideoThumbnailLocation?: string | null | undefined, signedPosterLocation?: string | null | undefined, encodeProgress: number, format?: string | null | undefined, durationSeconds?: number | null | undefined, backgroundVolume: number, mediaVolume: number, clips: Array<{ __typename?: 'Clip', startMs: number, endMs: number, rotation: number }> }> | null | undefined, renders?: Array<{ __typename?: 'Render', id: string, formFactor?: ProductFormFactor | null | undefined, task: string, gain: number, orientation: string, url?: string | null | undefined, signedURL?: string | null | undefined, encodeProgress?: number | null | undefined, encodeAttempts?: number | null | undefined }> | null | undefined } | null | undefined, destinations?: Array<{ __typename?: 'Destination', id: string, designId: string, state: string, coverId?: string | null | undefined, quantity: number, shippingSpeed?: string | null | undefined, shippingServiceCode?: string | null | undefined, giftMessage?: { __typename?: 'Message', body: string } | null | undefined, extras?: Array<{ __typename?: 'Extra', id: string }> | null | undefined, address?: { __typename?: 'Address', fullName: string, companyName?: string | null | undefined, street1: string, street2?: string | null | undefined, cityLocality: string, countryCode: string, stateProvinceCode: string, postalCode: string, phoneNumber?: string | null | undefined, nickname?: string | null | undefined } | null | undefined }> | null | undefined }> | null | undefined } };

export type RemoveExtraMutationVariables = Exact<{
  destinationId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type RemoveExtraMutation = { __typename?: 'Mutation', removeExtra: { __typename?: 'Order', id: string, state: OrderState, createdAt: any, paidAt?: any | null | undefined, finalizedAt?: any | null | undefined, cancelledAt?: any | null | undefined, discountId?: string | null | undefined, cost?: { __typename?: 'Pricing', total: { __typename?: 'Costs', product: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, shipping: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, tax: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, total: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, balanceUsed: { __typename?: 'CustomerBalance', cashInCents: number, products: Array<{ __typename?: 'CustomerBalanceProduct', quantity: number, product: { __typename?: 'Product', id: string, createdAt: any, displayName: string, type: ProductType, sizeIn?: number | null | undefined, formFactor?: ProductFormFactor | null | undefined, durationSec?: number | null | undefined, image?: string | null | undefined, allowSale: boolean, priceInCents: number }, entries: Array<{ __typename?: 'BalanceEntry', id: string, createdAt: any, originalCashInCents: number, cashRemainingInCents: number, vendorDisplayName: string, products: Array<{ __typename?: 'BalanceEntryProduct', productId: string, originalQuantity: number, quantityRemaining: number }> }> }> } }, byDestination: Array<{ __typename?: 'DestinationCosts', destinationId: string, costs: { __typename?: 'Costs', product: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, shipping: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, tax: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, total: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, balanceUsed: { __typename?: 'CustomerBalance', cashInCents: number, products: Array<{ __typename?: 'CustomerBalanceProduct', quantity: number, product: { __typename?: 'Product', id: string, createdAt: any, displayName: string, type: ProductType, sizeIn?: number | null | undefined, formFactor?: ProductFormFactor | null | undefined, durationSec?: number | null | undefined, image?: string | null | undefined, allowSale: boolean, priceInCents: number }, entries: Array<{ __typename?: 'BalanceEntry', id: string, createdAt: any, originalCashInCents: number, cashRemainingInCents: number, vendorDisplayName: string, products: Array<{ __typename?: 'BalanceEntryProduct', productId: string, originalQuantity: number, quantityRemaining: number }> }> }> } } }> } | null | undefined, designs?: Array<{ __typename?: 'DesignWithDestinations', design?: { __typename?: 'Design', id: string, createdAt: any, durationSeconds: number, generation: string, media?: Array<{ __typename?: 'MediaEntry', id: string, type?: string | null | undefined, encodedLocation: string, signedEncodedLocation?: string | null | undefined, signedThumbnailLocation?: string | null | undefined, signedVideoThumbnailLocation?: string | null | undefined, signedPosterLocation?: string | null | undefined, encodeProgress: number, format?: string | null | undefined, durationSeconds?: number | null | undefined, backgroundVolume: number, mediaVolume: number, clips: Array<{ __typename?: 'Clip', startMs: number, endMs: number, rotation: number }> }> | null | undefined, renders?: Array<{ __typename?: 'Render', id: string, formFactor?: ProductFormFactor | null | undefined, task: string, gain: number, orientation: string, url?: string | null | undefined, signedURL?: string | null | undefined, encodeProgress?: number | null | undefined, encodeAttempts?: number | null | undefined }> | null | undefined } | null | undefined, destinations?: Array<{ __typename?: 'Destination', id: string, designId: string, state: string, coverId?: string | null | undefined, quantity: number, shippingSpeed?: string | null | undefined, shippingServiceCode?: string | null | undefined, giftMessage?: { __typename?: 'Message', body: string } | null | undefined, extras?: Array<{ __typename?: 'Extra', id: string }> | null | undefined, address?: { __typename?: 'Address', fullName: string, companyName?: string | null | undefined, street1: string, street2?: string | null | undefined, cityLocality: string, countryCode: string, stateProvinceCode: string, postalCode: string, phoneNumber?: string | null | undefined, nickname?: string | null | undefined } | null | undefined }> | null | undefined }> | null | undefined } };

export type ShippingOptionsQueryVariables = Exact<{
  destinationId: Scalars['ID'];
}>;


export type ShippingOptionsQuery = { __typename?: 'Query', shippingOptions: Array<{ __typename?: 'ShippingOption', shippingSpeed?: string | null | undefined, serviceCode?: string | null | undefined, displayName: string, displayArrival?: string | null | undefined, arrivalDate?: any | null | undefined, cost: { __typename?: 'Cost', currency: Currency, actualInCents: number, listInCents: number } }> };

export type StockQueryVariables = Exact<{ [key: string]: never; }>;


export type StockQuery = { __typename?: 'Query', stock: { __typename?: 'Stock', books: Array<{ __typename?: 'BookStockEntry', id: string, durations: Array<{ __typename?: 'DurationStockEntry', id: string, displayName: string, ifLessThanDurationSec: number, quantity: number }>, covers: Array<{ __typename?: 'StockEntry', id: string, displayName: string, images?: Array<string> | null | undefined, quantity: number }>, extras: Array<{ __typename?: 'StockEntry', id: string, displayName: string, images?: Array<string> | null | undefined, quantity: number }> }> } };

export type UpdateAddressMutationVariables = Exact<{
  destinationId: Scalars['ID'];
  address: AddressInput;
}>;


export type UpdateAddressMutation = { __typename?: 'Mutation', updateAddress: { __typename?: 'AddressValidationResponse', valid: boolean, messages: Array<{ __typename?: 'AddressValidationMessage', type: string, code: string, message: string }>, order: { __typename?: 'Order', id: string, state: OrderState, createdAt: any, paidAt?: any | null | undefined, finalizedAt?: any | null | undefined, cancelledAt?: any | null | undefined, discountId?: string | null | undefined, cost?: { __typename?: 'Pricing', total: { __typename?: 'Costs', product: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, shipping: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, tax: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, total: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, balanceUsed: { __typename?: 'CustomerBalance', cashInCents: number, products: Array<{ __typename?: 'CustomerBalanceProduct', quantity: number, product: { __typename?: 'Product', id: string, createdAt: any, displayName: string, type: ProductType, sizeIn?: number | null | undefined, formFactor?: ProductFormFactor | null | undefined, durationSec?: number | null | undefined, image?: string | null | undefined, allowSale: boolean, priceInCents: number }, entries: Array<{ __typename?: 'BalanceEntry', id: string, createdAt: any, originalCashInCents: number, cashRemainingInCents: number, vendorDisplayName: string, products: Array<{ __typename?: 'BalanceEntryProduct', productId: string, originalQuantity: number, quantityRemaining: number }> }> }> } }, byDestination: Array<{ __typename?: 'DestinationCosts', destinationId: string, costs: { __typename?: 'Costs', product: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, shipping: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, tax: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, total: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, balanceUsed: { __typename?: 'CustomerBalance', cashInCents: number, products: Array<{ __typename?: 'CustomerBalanceProduct', quantity: number, product: { __typename?: 'Product', id: string, createdAt: any, displayName: string, type: ProductType, sizeIn?: number | null | undefined, formFactor?: ProductFormFactor | null | undefined, durationSec?: number | null | undefined, image?: string | null | undefined, allowSale: boolean, priceInCents: number }, entries: Array<{ __typename?: 'BalanceEntry', id: string, createdAt: any, originalCashInCents: number, cashRemainingInCents: number, vendorDisplayName: string, products: Array<{ __typename?: 'BalanceEntryProduct', productId: string, originalQuantity: number, quantityRemaining: number }> }> }> } } }> } | null | undefined, designs?: Array<{ __typename?: 'DesignWithDestinations', design?: { __typename?: 'Design', id: string, createdAt: any, durationSeconds: number, generation: string, media?: Array<{ __typename?: 'MediaEntry', id: string, type?: string | null | undefined, encodedLocation: string, signedEncodedLocation?: string | null | undefined, signedThumbnailLocation?: string | null | undefined, signedVideoThumbnailLocation?: string | null | undefined, signedPosterLocation?: string | null | undefined, encodeProgress: number, format?: string | null | undefined, durationSeconds?: number | null | undefined, backgroundVolume: number, mediaVolume: number, clips: Array<{ __typename?: 'Clip', startMs: number, endMs: number, rotation: number }> }> | null | undefined, renders?: Array<{ __typename?: 'Render', id: string, formFactor?: ProductFormFactor | null | undefined, task: string, gain: number, orientation: string, url?: string | null | undefined, signedURL?: string | null | undefined, encodeProgress?: number | null | undefined, encodeAttempts?: number | null | undefined }> | null | undefined } | null | undefined, destinations?: Array<{ __typename?: 'Destination', id: string, designId: string, state: string, coverId?: string | null | undefined, quantity: number, shippingSpeed?: string | null | undefined, shippingServiceCode?: string | null | undefined, giftMessage?: { __typename?: 'Message', body: string } | null | undefined, extras?: Array<{ __typename?: 'Extra', id: string }> | null | undefined, address?: { __typename?: 'Address', fullName: string, companyName?: string | null | undefined, street1: string, street2?: string | null | undefined, cityLocality: string, countryCode: string, stateProvinceCode: string, postalCode: string, phoneNumber?: string | null | undefined, nickname?: string | null | undefined } | null | undefined }> | null | undefined }> | null | undefined } } };

export type UpdateCoverMutationVariables = Exact<{
  destinationId: Scalars['ID'];
  coverId: Scalars['ID'];
}>;


export type UpdateCoverMutation = { __typename?: 'Mutation', updateCover: { __typename?: 'Order', id: string, state: OrderState, createdAt: any, paidAt?: any | null | undefined, finalizedAt?: any | null | undefined, cancelledAt?: any | null | undefined, discountId?: string | null | undefined, cost?: { __typename?: 'Pricing', total: { __typename?: 'Costs', product: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, shipping: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, tax: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, total: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, balanceUsed: { __typename?: 'CustomerBalance', cashInCents: number, products: Array<{ __typename?: 'CustomerBalanceProduct', quantity: number, product: { __typename?: 'Product', id: string, createdAt: any, displayName: string, type: ProductType, sizeIn?: number | null | undefined, formFactor?: ProductFormFactor | null | undefined, durationSec?: number | null | undefined, image?: string | null | undefined, allowSale: boolean, priceInCents: number }, entries: Array<{ __typename?: 'BalanceEntry', id: string, createdAt: any, originalCashInCents: number, cashRemainingInCents: number, vendorDisplayName: string, products: Array<{ __typename?: 'BalanceEntryProduct', productId: string, originalQuantity: number, quantityRemaining: number }> }> }> } }, byDestination: Array<{ __typename?: 'DestinationCosts', destinationId: string, costs: { __typename?: 'Costs', product: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, shipping: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, tax: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, total: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, balanceUsed: { __typename?: 'CustomerBalance', cashInCents: number, products: Array<{ __typename?: 'CustomerBalanceProduct', quantity: number, product: { __typename?: 'Product', id: string, createdAt: any, displayName: string, type: ProductType, sizeIn?: number | null | undefined, formFactor?: ProductFormFactor | null | undefined, durationSec?: number | null | undefined, image?: string | null | undefined, allowSale: boolean, priceInCents: number }, entries: Array<{ __typename?: 'BalanceEntry', id: string, createdAt: any, originalCashInCents: number, cashRemainingInCents: number, vendorDisplayName: string, products: Array<{ __typename?: 'BalanceEntryProduct', productId: string, originalQuantity: number, quantityRemaining: number }> }> }> } } }> } | null | undefined, designs?: Array<{ __typename?: 'DesignWithDestinations', design?: { __typename?: 'Design', id: string, createdAt: any, durationSeconds: number, generation: string, media?: Array<{ __typename?: 'MediaEntry', id: string, type?: string | null | undefined, encodedLocation: string, signedEncodedLocation?: string | null | undefined, signedThumbnailLocation?: string | null | undefined, signedVideoThumbnailLocation?: string | null | undefined, signedPosterLocation?: string | null | undefined, encodeProgress: number, format?: string | null | undefined, durationSeconds?: number | null | undefined, backgroundVolume: number, mediaVolume: number, clips: Array<{ __typename?: 'Clip', startMs: number, endMs: number, rotation: number }> }> | null | undefined, renders?: Array<{ __typename?: 'Render', id: string, formFactor?: ProductFormFactor | null | undefined, task: string, gain: number, orientation: string, url?: string | null | undefined, signedURL?: string | null | undefined, encodeProgress?: number | null | undefined, encodeAttempts?: number | null | undefined }> | null | undefined } | null | undefined, destinations?: Array<{ __typename?: 'Destination', id: string, designId: string, state: string, coverId?: string | null | undefined, quantity: number, shippingSpeed?: string | null | undefined, shippingServiceCode?: string | null | undefined, giftMessage?: { __typename?: 'Message', body: string } | null | undefined, extras?: Array<{ __typename?: 'Extra', id: string }> | null | undefined, address?: { __typename?: 'Address', fullName: string, companyName?: string | null | undefined, street1: string, street2?: string | null | undefined, cityLocality: string, countryCode: string, stateProvinceCode: string, postalCode: string, phoneNumber?: string | null | undefined, nickname?: string | null | undefined } | null | undefined }> | null | undefined }> | null | undefined } };

export type UpdateGiftMessageMutationVariables = Exact<{
  destinationId: Scalars['ID'];
  message: MessageInput;
}>;


export type UpdateGiftMessageMutation = { __typename?: 'Mutation', updateGiftMessage: { __typename?: 'Order', id: string, state: OrderState, createdAt: any, paidAt?: any | null | undefined, finalizedAt?: any | null | undefined, cancelledAt?: any | null | undefined, discountId?: string | null | undefined, cost?: { __typename?: 'Pricing', total: { __typename?: 'Costs', product: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, shipping: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, tax: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, total: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, balanceUsed: { __typename?: 'CustomerBalance', cashInCents: number, products: Array<{ __typename?: 'CustomerBalanceProduct', quantity: number, product: { __typename?: 'Product', id: string, createdAt: any, displayName: string, type: ProductType, sizeIn?: number | null | undefined, formFactor?: ProductFormFactor | null | undefined, durationSec?: number | null | undefined, image?: string | null | undefined, allowSale: boolean, priceInCents: number }, entries: Array<{ __typename?: 'BalanceEntry', id: string, createdAt: any, originalCashInCents: number, cashRemainingInCents: number, vendorDisplayName: string, products: Array<{ __typename?: 'BalanceEntryProduct', productId: string, originalQuantity: number, quantityRemaining: number }> }> }> } }, byDestination: Array<{ __typename?: 'DestinationCosts', destinationId: string, costs: { __typename?: 'Costs', product: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, shipping: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, tax: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, total: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, balanceUsed: { __typename?: 'CustomerBalance', cashInCents: number, products: Array<{ __typename?: 'CustomerBalanceProduct', quantity: number, product: { __typename?: 'Product', id: string, createdAt: any, displayName: string, type: ProductType, sizeIn?: number | null | undefined, formFactor?: ProductFormFactor | null | undefined, durationSec?: number | null | undefined, image?: string | null | undefined, allowSale: boolean, priceInCents: number }, entries: Array<{ __typename?: 'BalanceEntry', id: string, createdAt: any, originalCashInCents: number, cashRemainingInCents: number, vendorDisplayName: string, products: Array<{ __typename?: 'BalanceEntryProduct', productId: string, originalQuantity: number, quantityRemaining: number }> }> }> } } }> } | null | undefined, designs?: Array<{ __typename?: 'DesignWithDestinations', design?: { __typename?: 'Design', id: string, createdAt: any, durationSeconds: number, generation: string, media?: Array<{ __typename?: 'MediaEntry', id: string, type?: string | null | undefined, encodedLocation: string, signedEncodedLocation?: string | null | undefined, signedThumbnailLocation?: string | null | undefined, signedVideoThumbnailLocation?: string | null | undefined, signedPosterLocation?: string | null | undefined, encodeProgress: number, format?: string | null | undefined, durationSeconds?: number | null | undefined, backgroundVolume: number, mediaVolume: number, clips: Array<{ __typename?: 'Clip', startMs: number, endMs: number, rotation: number }> }> | null | undefined, renders?: Array<{ __typename?: 'Render', id: string, formFactor?: ProductFormFactor | null | undefined, task: string, gain: number, orientation: string, url?: string | null | undefined, signedURL?: string | null | undefined, encodeProgress?: number | null | undefined, encodeAttempts?: number | null | undefined }> | null | undefined } | null | undefined, destinations?: Array<{ __typename?: 'Destination', id: string, designId: string, state: string, coverId?: string | null | undefined, quantity: number, shippingSpeed?: string | null | undefined, shippingServiceCode?: string | null | undefined, giftMessage?: { __typename?: 'Message', body: string } | null | undefined, extras?: Array<{ __typename?: 'Extra', id: string }> | null | undefined, address?: { __typename?: 'Address', fullName: string, companyName?: string | null | undefined, street1: string, street2?: string | null | undefined, cityLocality: string, countryCode: string, stateProvinceCode: string, postalCode: string, phoneNumber?: string | null | undefined, nickname?: string | null | undefined } | null | undefined }> | null | undefined }> | null | undefined } };

export type UpdateMediaMutationVariables = Exact<{
  designID: Scalars['ID'];
  media: Array<Scalars['ID']> | Scalars['ID'];
  ifPrevGenerationMatches?: InputMaybe<Scalars['ID']>;
}>;


export type UpdateMediaMutation = { __typename?: 'Mutation', updateMedia: { __typename?: 'Design', id: string, createdAt: any, durationSeconds: number, generation: string, media?: Array<{ __typename?: 'MediaEntry', id: string, type?: string | null | undefined, encodedLocation: string, signedEncodedLocation?: string | null | undefined, signedThumbnailLocation?: string | null | undefined, signedVideoThumbnailLocation?: string | null | undefined, signedPosterLocation?: string | null | undefined, encodeProgress: number, format?: string | null | undefined, durationSeconds?: number | null | undefined, backgroundVolume: number, mediaVolume: number, clips: Array<{ __typename?: 'Clip', startMs: number, endMs: number, rotation: number }> }> | null | undefined, renders?: Array<{ __typename?: 'Render', id: string, formFactor?: ProductFormFactor | null | undefined, task: string, gain: number, orientation: string, url?: string | null | undefined, signedURL?: string | null | undefined, encodeProgress?: number | null | undefined, encodeAttempts?: number | null | undefined }> | null | undefined } };

export type UpdateOrientationMutationVariables = Exact<{
  designId: Scalars['ID'];
  orientation?: InputMaybe<Orientation>;
}>;


export type UpdateOrientationMutation = { __typename?: 'Mutation', updateOrientation: { __typename?: 'DesignResponse', design: { __typename?: 'Design', id: string, createdAt: any, durationSeconds: number, generation: string, media?: Array<{ __typename?: 'MediaEntry', id: string, type?: string | null | undefined, encodedLocation: string, signedEncodedLocation?: string | null | undefined, signedThumbnailLocation?: string | null | undefined, signedVideoThumbnailLocation?: string | null | undefined, signedPosterLocation?: string | null | undefined, encodeProgress: number, format?: string | null | undefined, durationSeconds?: number | null | undefined, backgroundVolume: number, mediaVolume: number, clips: Array<{ __typename?: 'Clip', startMs: number, endMs: number, rotation: number }> }> | null | undefined, renders?: Array<{ __typename?: 'Render', id: string, formFactor?: ProductFormFactor | null | undefined, task: string, gain: number, orientation: string, url?: string | null | undefined, signedURL?: string | null | undefined, encodeProgress?: number | null | undefined, encodeAttempts?: number | null | undefined }> | null | undefined } } };

export type UpdateQuantityMutationVariables = Exact<{
  destinationId: Scalars['ID'];
  quantity: Scalars['Int'];
}>;


export type UpdateQuantityMutation = { __typename?: 'Mutation', updateQuantity: { __typename?: 'Order', id: string, state: OrderState, createdAt: any, paidAt?: any | null | undefined, finalizedAt?: any | null | undefined, cancelledAt?: any | null | undefined, discountId?: string | null | undefined, cost?: { __typename?: 'Pricing', total: { __typename?: 'Costs', product: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, shipping: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, tax: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, total: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, balanceUsed: { __typename?: 'CustomerBalance', cashInCents: number, products: Array<{ __typename?: 'CustomerBalanceProduct', quantity: number, product: { __typename?: 'Product', id: string, createdAt: any, displayName: string, type: ProductType, sizeIn?: number | null | undefined, formFactor?: ProductFormFactor | null | undefined, durationSec?: number | null | undefined, image?: string | null | undefined, allowSale: boolean, priceInCents: number }, entries: Array<{ __typename?: 'BalanceEntry', id: string, createdAt: any, originalCashInCents: number, cashRemainingInCents: number, vendorDisplayName: string, products: Array<{ __typename?: 'BalanceEntryProduct', productId: string, originalQuantity: number, quantityRemaining: number }> }> }> } }, byDestination: Array<{ __typename?: 'DestinationCosts', destinationId: string, costs: { __typename?: 'Costs', product: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, shipping: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, tax: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, total: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, balanceUsed: { __typename?: 'CustomerBalance', cashInCents: number, products: Array<{ __typename?: 'CustomerBalanceProduct', quantity: number, product: { __typename?: 'Product', id: string, createdAt: any, displayName: string, type: ProductType, sizeIn?: number | null | undefined, formFactor?: ProductFormFactor | null | undefined, durationSec?: number | null | undefined, image?: string | null | undefined, allowSale: boolean, priceInCents: number }, entries: Array<{ __typename?: 'BalanceEntry', id: string, createdAt: any, originalCashInCents: number, cashRemainingInCents: number, vendorDisplayName: string, products: Array<{ __typename?: 'BalanceEntryProduct', productId: string, originalQuantity: number, quantityRemaining: number }> }> }> } } }> } | null | undefined, designs?: Array<{ __typename?: 'DesignWithDestinations', design?: { __typename?: 'Design', id: string, createdAt: any, durationSeconds: number, generation: string, media?: Array<{ __typename?: 'MediaEntry', id: string, type?: string | null | undefined, encodedLocation: string, signedEncodedLocation?: string | null | undefined, signedThumbnailLocation?: string | null | undefined, signedVideoThumbnailLocation?: string | null | undefined, signedPosterLocation?: string | null | undefined, encodeProgress: number, format?: string | null | undefined, durationSeconds?: number | null | undefined, backgroundVolume: number, mediaVolume: number, clips: Array<{ __typename?: 'Clip', startMs: number, endMs: number, rotation: number }> }> | null | undefined, renders?: Array<{ __typename?: 'Render', id: string, formFactor?: ProductFormFactor | null | undefined, task: string, gain: number, orientation: string, url?: string | null | undefined, signedURL?: string | null | undefined, encodeProgress?: number | null | undefined, encodeAttempts?: number | null | undefined }> | null | undefined } | null | undefined, destinations?: Array<{ __typename?: 'Destination', id: string, designId: string, state: string, coverId?: string | null | undefined, quantity: number, shippingSpeed?: string | null | undefined, shippingServiceCode?: string | null | undefined, giftMessage?: { __typename?: 'Message', body: string } | null | undefined, extras?: Array<{ __typename?: 'Extra', id: string }> | null | undefined, address?: { __typename?: 'Address', fullName: string, companyName?: string | null | undefined, street1: string, street2?: string | null | undefined, cityLocality: string, countryCode: string, stateProvinceCode: string, postalCode: string, phoneNumber?: string | null | undefined, nickname?: string | null | undefined } | null | undefined }> | null | undefined }> | null | undefined } };

export type UpdateShippingChoiceMutationVariables = Exact<{
  destinationId: Scalars['ID'];
  choice: ShippingChoice;
}>;


export type UpdateShippingChoiceMutation = { __typename?: 'Mutation', updateShippingChoice: { __typename?: 'Order', id: string, state: OrderState, createdAt: any, paidAt?: any | null | undefined, finalizedAt?: any | null | undefined, cancelledAt?: any | null | undefined, discountId?: string | null | undefined, cost?: { __typename?: 'Pricing', total: { __typename?: 'Costs', product: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, shipping: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, tax: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, total: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, balanceUsed: { __typename?: 'CustomerBalance', cashInCents: number, products: Array<{ __typename?: 'CustomerBalanceProduct', quantity: number, product: { __typename?: 'Product', id: string, createdAt: any, displayName: string, type: ProductType, sizeIn?: number | null | undefined, formFactor?: ProductFormFactor | null | undefined, durationSec?: number | null | undefined, image?: string | null | undefined, allowSale: boolean, priceInCents: number }, entries: Array<{ __typename?: 'BalanceEntry', id: string, createdAt: any, originalCashInCents: number, cashRemainingInCents: number, vendorDisplayName: string, products: Array<{ __typename?: 'BalanceEntryProduct', productId: string, originalQuantity: number, quantityRemaining: number }> }> }> } }, byDestination: Array<{ __typename?: 'DestinationCosts', destinationId: string, costs: { __typename?: 'Costs', product: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, shipping: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, tax: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, total: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, balanceUsed: { __typename?: 'CustomerBalance', cashInCents: number, products: Array<{ __typename?: 'CustomerBalanceProduct', quantity: number, product: { __typename?: 'Product', id: string, createdAt: any, displayName: string, type: ProductType, sizeIn?: number | null | undefined, formFactor?: ProductFormFactor | null | undefined, durationSec?: number | null | undefined, image?: string | null | undefined, allowSale: boolean, priceInCents: number }, entries: Array<{ __typename?: 'BalanceEntry', id: string, createdAt: any, originalCashInCents: number, cashRemainingInCents: number, vendorDisplayName: string, products: Array<{ __typename?: 'BalanceEntryProduct', productId: string, originalQuantity: number, quantityRemaining: number }> }> }> } } }> } | null | undefined, designs?: Array<{ __typename?: 'DesignWithDestinations', design?: { __typename?: 'Design', id: string, createdAt: any, durationSeconds: number, generation: string, media?: Array<{ __typename?: 'MediaEntry', id: string, type?: string | null | undefined, encodedLocation: string, signedEncodedLocation?: string | null | undefined, signedThumbnailLocation?: string | null | undefined, signedVideoThumbnailLocation?: string | null | undefined, signedPosterLocation?: string | null | undefined, encodeProgress: number, format?: string | null | undefined, durationSeconds?: number | null | undefined, backgroundVolume: number, mediaVolume: number, clips: Array<{ __typename?: 'Clip', startMs: number, endMs: number, rotation: number }> }> | null | undefined, renders?: Array<{ __typename?: 'Render', id: string, formFactor?: ProductFormFactor | null | undefined, task: string, gain: number, orientation: string, url?: string | null | undefined, signedURL?: string | null | undefined, encodeProgress?: number | null | undefined, encodeAttempts?: number | null | undefined }> | null | undefined } | null | undefined, destinations?: Array<{ __typename?: 'Destination', id: string, designId: string, state: string, coverId?: string | null | undefined, quantity: number, shippingSpeed?: string | null | undefined, shippingServiceCode?: string | null | undefined, giftMessage?: { __typename?: 'Message', body: string } | null | undefined, extras?: Array<{ __typename?: 'Extra', id: string }> | null | undefined, address?: { __typename?: 'Address', fullName: string, companyName?: string | null | undefined, street1: string, street2?: string | null | undefined, cityLocality: string, countryCode: string, stateProvinceCode: string, postalCode: string, phoneNumber?: string | null | undefined, nickname?: string | null | undefined } | null | undefined }> | null | undefined }> | null | undefined } };

export type AddressFragment = { __typename?: 'Address', fullName: string, companyName?: string | null | undefined, street1: string, street2?: string | null | undefined, cityLocality: string, countryCode: string, stateProvinceCode: string, postalCode: string, phoneNumber?: string | null | undefined, nickname?: string | null | undefined };

export type BalanceEntryFragment = { __typename?: 'BalanceEntry', id: string, createdAt: any, originalCashInCents: number, cashRemainingInCents: number, vendorDisplayName: string, products: Array<{ __typename?: 'BalanceEntryProduct', productId: string, originalQuantity: number, quantityRemaining: number }> };

export type BalanceEntryProductFragment = { __typename?: 'BalanceEntryProduct', productId: string, originalQuantity: number, quantityRemaining: number };

export type ClipFragment = { __typename?: 'Clip', startMs: number, endMs: number, rotation: number };

export type CostsFragment = { __typename?: 'Costs', product: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, shipping: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, tax: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, total: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, balanceUsed: { __typename?: 'CustomerBalance', cashInCents: number, products: Array<{ __typename?: 'CustomerBalanceProduct', quantity: number, product: { __typename?: 'Product', id: string, createdAt: any, displayName: string, type: ProductType, sizeIn?: number | null | undefined, formFactor?: ProductFormFactor | null | undefined, durationSec?: number | null | undefined, image?: string | null | undefined, allowSale: boolean, priceInCents: number }, entries: Array<{ __typename?: 'BalanceEntry', id: string, createdAt: any, originalCashInCents: number, cashRemainingInCents: number, vendorDisplayName: string, products: Array<{ __typename?: 'BalanceEntryProduct', productId: string, originalQuantity: number, quantityRemaining: number }> }> }> } };

export type CustomerFragment = { __typename?: 'Customer', id: string, createdAt: any, email: string, balance?: { __typename?: 'CustomerBalance', cashInCents: number, products: Array<{ __typename?: 'CustomerBalanceProduct', quantity: number, product: { __typename?: 'Product', id: string, createdAt: any, displayName: string, type: ProductType, sizeIn?: number | null | undefined, formFactor?: ProductFormFactor | null | undefined, durationSec?: number | null | undefined, image?: string | null | undefined, allowSale: boolean, priceInCents: number }, entries: Array<{ __typename?: 'BalanceEntry', id: string, createdAt: any, originalCashInCents: number, cashRemainingInCents: number, vendorDisplayName: string, products: Array<{ __typename?: 'BalanceEntryProduct', productId: string, originalQuantity: number, quantityRemaining: number }> }> }> } | null | undefined };

export type CustomerBalanceFragment = { __typename?: 'CustomerBalance', cashInCents: number, products: Array<{ __typename?: 'CustomerBalanceProduct', quantity: number, product: { __typename?: 'Product', id: string, createdAt: any, displayName: string, type: ProductType, sizeIn?: number | null | undefined, formFactor?: ProductFormFactor | null | undefined, durationSec?: number | null | undefined, image?: string | null | undefined, allowSale: boolean, priceInCents: number }, entries: Array<{ __typename?: 'BalanceEntry', id: string, createdAt: any, originalCashInCents: number, cashRemainingInCents: number, vendorDisplayName: string, products: Array<{ __typename?: 'BalanceEntryProduct', productId: string, originalQuantity: number, quantityRemaining: number }> }> }> };

export type CustomerBalanceProductFragment = { __typename?: 'CustomerBalanceProduct', quantity: number, product: { __typename?: 'Product', id: string, createdAt: any, displayName: string, type: ProductType, sizeIn?: number | null | undefined, formFactor?: ProductFormFactor | null | undefined, durationSec?: number | null | undefined, image?: string | null | undefined, allowSale: boolean, priceInCents: number }, entries: Array<{ __typename?: 'BalanceEntry', id: string, createdAt: any, originalCashInCents: number, cashRemainingInCents: number, vendorDisplayName: string, products: Array<{ __typename?: 'BalanceEntryProduct', productId: string, originalQuantity: number, quantityRemaining: number }> }> };

export type DesignFragment = { __typename?: 'Design', id: string, createdAt: any, durationSeconds: number, generation: string, media?: Array<{ __typename?: 'MediaEntry', id: string, type?: string | null | undefined, encodedLocation: string, signedEncodedLocation?: string | null | undefined, signedThumbnailLocation?: string | null | undefined, signedVideoThumbnailLocation?: string | null | undefined, signedPosterLocation?: string | null | undefined, encodeProgress: number, format?: string | null | undefined, durationSeconds?: number | null | undefined, backgroundVolume: number, mediaVolume: number, clips: Array<{ __typename?: 'Clip', startMs: number, endMs: number, rotation: number }> }> | null | undefined, renders?: Array<{ __typename?: 'Render', id: string, formFactor?: ProductFormFactor | null | undefined, task: string, gain: number, orientation: string, url?: string | null | undefined, signedURL?: string | null | undefined, encodeProgress?: number | null | undefined, encodeAttempts?: number | null | undefined }> | null | undefined };

export type DesignWithDestinationsFragment = { __typename?: 'DesignWithDestinations', design?: { __typename?: 'Design', id: string, createdAt: any, durationSeconds: number, generation: string, media?: Array<{ __typename?: 'MediaEntry', id: string, type?: string | null | undefined, encodedLocation: string, signedEncodedLocation?: string | null | undefined, signedThumbnailLocation?: string | null | undefined, signedVideoThumbnailLocation?: string | null | undefined, signedPosterLocation?: string | null | undefined, encodeProgress: number, format?: string | null | undefined, durationSeconds?: number | null | undefined, backgroundVolume: number, mediaVolume: number, clips: Array<{ __typename?: 'Clip', startMs: number, endMs: number, rotation: number }> }> | null | undefined, renders?: Array<{ __typename?: 'Render', id: string, formFactor?: ProductFormFactor | null | undefined, task: string, gain: number, orientation: string, url?: string | null | undefined, signedURL?: string | null | undefined, encodeProgress?: number | null | undefined, encodeAttempts?: number | null | undefined }> | null | undefined } | null | undefined, destinations?: Array<{ __typename?: 'Destination', id: string, designId: string, state: string, coverId?: string | null | undefined, quantity: number, shippingSpeed?: string | null | undefined, shippingServiceCode?: string | null | undefined, giftMessage?: { __typename?: 'Message', body: string } | null | undefined, extras?: Array<{ __typename?: 'Extra', id: string }> | null | undefined, address?: { __typename?: 'Address', fullName: string, companyName?: string | null | undefined, street1: string, street2?: string | null | undefined, cityLocality: string, countryCode: string, stateProvinceCode: string, postalCode: string, phoneNumber?: string | null | undefined, nickname?: string | null | undefined } | null | undefined }> | null | undefined };

export type DestinationFragment = { __typename?: 'Destination', id: string, designId: string, state: string, coverId?: string | null | undefined, quantity: number, shippingSpeed?: string | null | undefined, shippingServiceCode?: string | null | undefined, giftMessage?: { __typename?: 'Message', body: string } | null | undefined, extras?: Array<{ __typename?: 'Extra', id: string }> | null | undefined, address?: { __typename?: 'Address', fullName: string, companyName?: string | null | undefined, street1: string, street2?: string | null | undefined, cityLocality: string, countryCode: string, stateProvinceCode: string, postalCode: string, phoneNumber?: string | null | undefined, nickname?: string | null | undefined } | null | undefined };

export type MediaEntryFragment = { __typename?: 'MediaEntry', id: string, type?: string | null | undefined, encodedLocation: string, signedEncodedLocation?: string | null | undefined, signedThumbnailLocation?: string | null | undefined, signedVideoThumbnailLocation?: string | null | undefined, signedPosterLocation?: string | null | undefined, encodeProgress: number, format?: string | null | undefined, durationSeconds?: number | null | undefined, backgroundVolume: number, mediaVolume: number, clips: Array<{ __typename?: 'Clip', startMs: number, endMs: number, rotation: number }> };

export type OrderFragment = { __typename?: 'Order', id: string, state: OrderState, createdAt: any, paidAt?: any | null | undefined, finalizedAt?: any | null | undefined, cancelledAt?: any | null | undefined, discountId?: string | null | undefined, cost?: { __typename?: 'Pricing', total: { __typename?: 'Costs', product: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, shipping: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, tax: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, total: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, balanceUsed: { __typename?: 'CustomerBalance', cashInCents: number, products: Array<{ __typename?: 'CustomerBalanceProduct', quantity: number, product: { __typename?: 'Product', id: string, createdAt: any, displayName: string, type: ProductType, sizeIn?: number | null | undefined, formFactor?: ProductFormFactor | null | undefined, durationSec?: number | null | undefined, image?: string | null | undefined, allowSale: boolean, priceInCents: number }, entries: Array<{ __typename?: 'BalanceEntry', id: string, createdAt: any, originalCashInCents: number, cashRemainingInCents: number, vendorDisplayName: string, products: Array<{ __typename?: 'BalanceEntryProduct', productId: string, originalQuantity: number, quantityRemaining: number }> }> }> } }, byDestination: Array<{ __typename?: 'DestinationCosts', destinationId: string, costs: { __typename?: 'Costs', product: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, shipping: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, tax: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, total: { __typename?: 'Cost', listInCents: number, actualInCents: number, discountInCents: number }, balanceUsed: { __typename?: 'CustomerBalance', cashInCents: number, products: Array<{ __typename?: 'CustomerBalanceProduct', quantity: number, product: { __typename?: 'Product', id: string, createdAt: any, displayName: string, type: ProductType, sizeIn?: number | null | undefined, formFactor?: ProductFormFactor | null | undefined, durationSec?: number | null | undefined, image?: string | null | undefined, allowSale: boolean, priceInCents: number }, entries: Array<{ __typename?: 'BalanceEntry', id: string, createdAt: any, originalCashInCents: number, cashRemainingInCents: number, vendorDisplayName: string, products: Array<{ __typename?: 'BalanceEntryProduct', productId: string, originalQuantity: number, quantityRemaining: number }> }> }> } } }> } | null | undefined, designs?: Array<{ __typename?: 'DesignWithDestinations', design?: { __typename?: 'Design', id: string, createdAt: any, durationSeconds: number, generation: string, media?: Array<{ __typename?: 'MediaEntry', id: string, type?: string | null | undefined, encodedLocation: string, signedEncodedLocation?: string | null | undefined, signedThumbnailLocation?: string | null | undefined, signedVideoThumbnailLocation?: string | null | undefined, signedPosterLocation?: string | null | undefined, encodeProgress: number, format?: string | null | undefined, durationSeconds?: number | null | undefined, backgroundVolume: number, mediaVolume: number, clips: Array<{ __typename?: 'Clip', startMs: number, endMs: number, rotation: number }> }> | null | undefined, renders?: Array<{ __typename?: 'Render', id: string, formFactor?: ProductFormFactor | null | undefined, task: string, gain: number, orientation: string, url?: string | null | undefined, signedURL?: string | null | undefined, encodeProgress?: number | null | undefined, encodeAttempts?: number | null | undefined }> | null | undefined } | null | undefined, destinations?: Array<{ __typename?: 'Destination', id: string, designId: string, state: string, coverId?: string | null | undefined, quantity: number, shippingSpeed?: string | null | undefined, shippingServiceCode?: string | null | undefined, giftMessage?: { __typename?: 'Message', body: string } | null | undefined, extras?: Array<{ __typename?: 'Extra', id: string }> | null | undefined, address?: { __typename?: 'Address', fullName: string, companyName?: string | null | undefined, street1: string, street2?: string | null | undefined, cityLocality: string, countryCode: string, stateProvinceCode: string, postalCode: string, phoneNumber?: string | null | undefined, nickname?: string | null | undefined } | null | undefined }> | null | undefined }> | null | undefined };

export type ProductFragment = { __typename?: 'Product', id: string, createdAt: any, displayName: string, type: ProductType, sizeIn?: number | null | undefined, formFactor?: ProductFormFactor | null | undefined, durationSec?: number | null | undefined, image?: string | null | undefined, allowSale: boolean, priceInCents: number };

export type RenderFragment = { __typename?: 'Render', id: string, formFactor?: ProductFormFactor | null | undefined, task: string, gain: number, orientation: string, url?: string | null | undefined, signedURL?: string | null | undefined, encodeProgress?: number | null | undefined, encodeAttempts?: number | null | undefined };

export type ShippingOptionFragment = { __typename?: 'ShippingOption', shippingSpeed?: string | null | undefined, serviceCode?: string | null | undefined, displayName: string, displayArrival?: string | null | undefined, arrivalDate?: any | null | undefined, cost: { __typename?: 'Cost', currency: Currency, actualInCents: number, listInCents: number } };

export type StockFragment = { __typename?: 'Stock', books: Array<{ __typename?: 'BookStockEntry', id: string, durations: Array<{ __typename?: 'DurationStockEntry', id: string, displayName: string, ifLessThanDurationSec: number, quantity: number }>, covers: Array<{ __typename?: 'StockEntry', id: string, displayName: string, images?: Array<string> | null | undefined, quantity: number }>, extras: Array<{ __typename?: 'StockEntry', id: string, displayName: string, images?: Array<string> | null | undefined, quantity: number }> }> };

export const ProductFragmentDoc = gql`
    fragment Product on Product {
  id
  createdAt
  displayName
  type
  sizeIn
  formFactor
  durationSec
  image
  allowSale
  priceInCents
}
    `;
export const BalanceEntryProductFragmentDoc = gql`
    fragment BalanceEntryProduct on BalanceEntryProduct {
  productId
  originalQuantity
  quantityRemaining
}
    `;
export const BalanceEntryFragmentDoc = gql`
    fragment BalanceEntry on BalanceEntry {
  id
  createdAt
  originalCashInCents
  cashRemainingInCents
  vendorDisplayName
  products {
    ...BalanceEntryProduct
  }
}
    ${BalanceEntryProductFragmentDoc}`;
export const CustomerBalanceProductFragmentDoc = gql`
    fragment CustomerBalanceProduct on CustomerBalanceProduct {
  quantity
  product {
    ...Product
  }
  entries {
    ...BalanceEntry
  }
}
    ${ProductFragmentDoc}
${BalanceEntryFragmentDoc}`;
export const CustomerBalanceFragmentDoc = gql`
    fragment CustomerBalance on CustomerBalance {
  cashInCents
  products {
    ...CustomerBalanceProduct
  }
}
    ${CustomerBalanceProductFragmentDoc}`;
export const CustomerFragmentDoc = gql`
    fragment Customer on Customer {
  id
  createdAt
  email
  balance {
    ...CustomerBalance
  }
}
    ${CustomerBalanceFragmentDoc}`;
export const CostsFragmentDoc = gql`
    fragment Costs on Costs {
  product {
    listInCents
    actualInCents
    discountInCents
  }
  shipping {
    listInCents
    actualInCents
    discountInCents
  }
  tax {
    listInCents
    actualInCents
    discountInCents
  }
  total {
    listInCents
    actualInCents
    discountInCents
  }
  balanceUsed {
    ...CustomerBalance
  }
}
    ${CustomerBalanceFragmentDoc}`;
export const ClipFragmentDoc = gql`
    fragment Clip on Clip {
  startMs
  endMs
  rotation
}
    `;
export const MediaEntryFragmentDoc = gql`
    fragment MediaEntry on MediaEntry {
  id
  type
  encodedLocation
  signedEncodedLocation
  signedThumbnailLocation
  signedVideoThumbnailLocation
  signedPosterLocation
  encodeProgress
  format
  durationSeconds
  backgroundVolume
  mediaVolume
  clips {
    ...Clip
  }
}
    ${ClipFragmentDoc}`;
export const RenderFragmentDoc = gql`
    fragment Render on Render {
  id
  formFactor
  task
  gain
  orientation
  url
  signedURL
  encodeProgress
  encodeAttempts
}
    `;
export const DesignFragmentDoc = gql`
    fragment Design on Design {
  id
  createdAt
  durationSeconds
  generation
  media {
    id
    ...MediaEntry
  }
  renders {
    id
    ...Render
  }
}
    ${MediaEntryFragmentDoc}
${RenderFragmentDoc}`;
export const AddressFragmentDoc = gql`
    fragment Address on Address {
  fullName
  companyName
  street1
  street2
  cityLocality
  countryCode
  stateProvinceCode
  postalCode
  phoneNumber
  nickname
}
    `;
export const DestinationFragmentDoc = gql`
    fragment Destination on Destination {
  id
  designId
  state
  coverId
  giftMessage {
    body
  }
  extras {
    id
  }
  quantity
  address {
    ...Address
  }
  shippingSpeed
  shippingServiceCode
}
    ${AddressFragmentDoc}`;
export const DesignWithDestinationsFragmentDoc = gql`
    fragment DesignWithDestinations on DesignWithDestinations {
  design {
    ...Design
  }
  destinations {
    ...Destination
  }
}
    ${DesignFragmentDoc}
${DestinationFragmentDoc}`;
export const OrderFragmentDoc = gql`
    fragment Order on Order {
  id
  state
  createdAt
  paidAt
  finalizedAt
  cancelledAt
  discountId
  cost {
    total {
      ...Costs
    }
    byDestination {
      destinationId
      costs {
        ...Costs
      }
    }
  }
  designs {
    ...DesignWithDestinations
  }
}
    ${CostsFragmentDoc}
${DesignWithDestinationsFragmentDoc}`;
export const ShippingOptionFragmentDoc = gql`
    fragment ShippingOption on ShippingOption {
  shippingSpeed
  serviceCode
  displayName
  displayArrival
  arrivalDate
  cost {
    currency
    actualInCents
    listInCents
  }
}
    `;
export const StockFragmentDoc = gql`
    fragment Stock on Stock {
  books {
    id
    durations {
      id
      displayName
      ifLessThanDurationSec
      quantity
    }
    covers {
      id
      displayName
      images
      quantity
    }
    extras {
      id
      displayName
      images
      quantity
    }
  }
}
    `;
export const AddDesignDocument = gql`
    mutation AddDesign($orderId: ID!, $cloneDesignId: ID) {
  addDesign(orderId: $orderId, cloneDesignId: $cloneDesignId) {
    order {
      ...Order
    }
    design {
      ...Design
    }
  }
}
    ${OrderFragmentDoc}
${DesignFragmentDoc}`;
export type AddDesignMutationFn = Apollo.MutationFunction<AddDesignMutation, AddDesignMutationVariables>;

/**
 * __useAddDesignMutation__
 *
 * To run a mutation, you first call `useAddDesignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDesignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDesignMutation, { data, loading, error }] = useAddDesignMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      cloneDesignId: // value for 'cloneDesignId'
 *   },
 * });
 */
export function useAddDesignMutation(baseOptions?: Apollo.MutationHookOptions<AddDesignMutation, AddDesignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDesignMutation, AddDesignMutationVariables>(AddDesignDocument, options);
      }
export type AddDesignMutationHookResult = ReturnType<typeof useAddDesignMutation>;
export type AddDesignMutationResult = Apollo.MutationResult<AddDesignMutation>;
export type AddDesignMutationOptions = Apollo.BaseMutationOptions<AddDesignMutation, AddDesignMutationVariables>;
export const AddDestinationDocument = gql`
    mutation AddDestination($orderId: ID!, $designId: ID!, $cloneDestinationId: ID) {
  addDestination(
    orderId: $orderId
    designId: $designId
    cloneDestinationId: $cloneDestinationId
  ) {
    ...Order
  }
}
    ${OrderFragmentDoc}`;
export type AddDestinationMutationFn = Apollo.MutationFunction<AddDestinationMutation, AddDestinationMutationVariables>;

/**
 * __useAddDestinationMutation__
 *
 * To run a mutation, you first call `useAddDestinationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDestinationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDestinationMutation, { data, loading, error }] = useAddDestinationMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      designId: // value for 'designId'
 *      cloneDestinationId: // value for 'cloneDestinationId'
 *   },
 * });
 */
export function useAddDestinationMutation(baseOptions?: Apollo.MutationHookOptions<AddDestinationMutation, AddDestinationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDestinationMutation, AddDestinationMutationVariables>(AddDestinationDocument, options);
      }
export type AddDestinationMutationHookResult = ReturnType<typeof useAddDestinationMutation>;
export type AddDestinationMutationResult = Apollo.MutationResult<AddDestinationMutation>;
export type AddDestinationMutationOptions = Apollo.BaseMutationOptions<AddDestinationMutation, AddDestinationMutationVariables>;
export const AddExtraDocument = gql`
    mutation AddExtra($destinationId: ID!, $extra: ExtraInput!) {
  addExtra(destinationId: $destinationId, extra: $extra) {
    ...Order
  }
}
    ${OrderFragmentDoc}`;
export type AddExtraMutationFn = Apollo.MutationFunction<AddExtraMutation, AddExtraMutationVariables>;

/**
 * __useAddExtraMutation__
 *
 * To run a mutation, you first call `useAddExtraMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddExtraMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addExtraMutation, { data, loading, error }] = useAddExtraMutation({
 *   variables: {
 *      destinationId: // value for 'destinationId'
 *      extra: // value for 'extra'
 *   },
 * });
 */
export function useAddExtraMutation(baseOptions?: Apollo.MutationHookOptions<AddExtraMutation, AddExtraMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddExtraMutation, AddExtraMutationVariables>(AddExtraDocument, options);
      }
export type AddExtraMutationHookResult = ReturnType<typeof useAddExtraMutation>;
export type AddExtraMutationResult = Apollo.MutationResult<AddExtraMutation>;
export type AddExtraMutationOptions = Apollo.BaseMutationOptions<AddExtraMutation, AddExtraMutationVariables>;
export const AppendMediaDocument = gql`
    mutation AppendMedia($designID: ID!, $media: [ID!]!) {
  appendMedia(designId: $designID, media: $media) {
    ...Design
  }
}
    ${DesignFragmentDoc}`;
export type AppendMediaMutationFn = Apollo.MutationFunction<AppendMediaMutation, AppendMediaMutationVariables>;

/**
 * __useAppendMediaMutation__
 *
 * To run a mutation, you first call `useAppendMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppendMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appendMediaMutation, { data, loading, error }] = useAppendMediaMutation({
 *   variables: {
 *      designID: // value for 'designID'
 *      media: // value for 'media'
 *   },
 * });
 */
export function useAppendMediaMutation(baseOptions?: Apollo.MutationHookOptions<AppendMediaMutation, AppendMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AppendMediaMutation, AppendMediaMutationVariables>(AppendMediaDocument, options);
      }
export type AppendMediaMutationHookResult = ReturnType<typeof useAppendMediaMutation>;
export type AppendMediaMutationResult = Apollo.MutationResult<AppendMediaMutation>;
export type AppendMediaMutationOptions = Apollo.BaseMutationOptions<AppendMediaMutation, AppendMediaMutationVariables>;
export const ApplyDiscountCodeDocument = gql`
    mutation ApplyDiscountCode($orderId: ID!, $discountId: String!) {
  applyDiscountCode(orderId: $orderId, discountId: $discountId) {
    ...Order
  }
}
    ${OrderFragmentDoc}`;
export type ApplyDiscountCodeMutationFn = Apollo.MutationFunction<ApplyDiscountCodeMutation, ApplyDiscountCodeMutationVariables>;

/**
 * __useApplyDiscountCodeMutation__
 *
 * To run a mutation, you first call `useApplyDiscountCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyDiscountCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyDiscountCodeMutation, { data, loading, error }] = useApplyDiscountCodeMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      discountId: // value for 'discountId'
 *   },
 * });
 */
export function useApplyDiscountCodeMutation(baseOptions?: Apollo.MutationHookOptions<ApplyDiscountCodeMutation, ApplyDiscountCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyDiscountCodeMutation, ApplyDiscountCodeMutationVariables>(ApplyDiscountCodeDocument, options);
      }
export type ApplyDiscountCodeMutationHookResult = ReturnType<typeof useApplyDiscountCodeMutation>;
export type ApplyDiscountCodeMutationResult = Apollo.MutationResult<ApplyDiscountCodeMutation>;
export type ApplyDiscountCodeMutationOptions = Apollo.BaseMutationOptions<ApplyDiscountCodeMutation, ApplyDiscountCodeMutationVariables>;
export const CreateDraftOrderDocument = gql`
    mutation CreateDraftOrder($order: NewOrder!) {
  createDraftOrder(order: $order) {
    order {
      id
      designs {
        design {
          id
        }
      }
    }
  }
}
    `;
export type CreateDraftOrderMutationFn = Apollo.MutationFunction<CreateDraftOrderMutation, CreateDraftOrderMutationVariables>;

/**
 * __useCreateDraftOrderMutation__
 *
 * To run a mutation, you first call `useCreateDraftOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDraftOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDraftOrderMutation, { data, loading, error }] = useCreateDraftOrderMutation({
 *   variables: {
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCreateDraftOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateDraftOrderMutation, CreateDraftOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDraftOrderMutation, CreateDraftOrderMutationVariables>(CreateDraftOrderDocument, options);
      }
export type CreateDraftOrderMutationHookResult = ReturnType<typeof useCreateDraftOrderMutation>;
export type CreateDraftOrderMutationResult = Apollo.MutationResult<CreateDraftOrderMutation>;
export type CreateDraftOrderMutationOptions = Apollo.BaseMutationOptions<CreateDraftOrderMutation, CreateDraftOrderMutationVariables>;
export const DesignDocument = gql`
    query Design($designId: ID!) {
  design(designId: $designId) {
    ...Design
  }
}
    ${DesignFragmentDoc}`;

/**
 * __useDesignQuery__
 *
 * To run a query within a React component, call `useDesignQuery` and pass it any options that fit your needs.
 * When your component renders, `useDesignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDesignQuery({
 *   variables: {
 *      designId: // value for 'designId'
 *   },
 * });
 */
export function useDesignQuery(baseOptions: Apollo.QueryHookOptions<DesignQuery, DesignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DesignQuery, DesignQueryVariables>(DesignDocument, options);
      }
export function useDesignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DesignQuery, DesignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DesignQuery, DesignQueryVariables>(DesignDocument, options);
        }
export type DesignQueryHookResult = ReturnType<typeof useDesignQuery>;
export type DesignLazyQueryHookResult = ReturnType<typeof useDesignLazyQuery>;
export type DesignQueryResult = Apollo.QueryResult<DesignQuery, DesignQueryVariables>;
export const DesignsDocument = gql`
    query Designs {
  designs {
    ...Design
  }
}
    ${DesignFragmentDoc}`;

/**
 * __useDesignsQuery__
 *
 * To run a query within a React component, call `useDesignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDesignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDesignsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDesignsQuery(baseOptions?: Apollo.QueryHookOptions<DesignsQuery, DesignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DesignsQuery, DesignsQueryVariables>(DesignsDocument, options);
      }
export function useDesignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DesignsQuery, DesignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DesignsQuery, DesignsQueryVariables>(DesignsDocument, options);
        }
export type DesignsQueryHookResult = ReturnType<typeof useDesignsQuery>;
export type DesignsLazyQueryHookResult = ReturnType<typeof useDesignsLazyQuery>;
export type DesignsQueryResult = Apollo.QueryResult<DesignsQuery, DesignsQueryVariables>;
export const EditMediaDocument = gql`
    mutation EditMedia($designId: ID!, $mediaEntryId: ID!, $media: MediaEntryEdit!) {
  editMedia(designId: $designId, mediaEntryId: $mediaEntryId, media: $media) {
    ...Design
  }
}
    ${DesignFragmentDoc}`;
export type EditMediaMutationFn = Apollo.MutationFunction<EditMediaMutation, EditMediaMutationVariables>;

/**
 * __useEditMediaMutation__
 *
 * To run a mutation, you first call `useEditMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMediaMutation, { data, loading, error }] = useEditMediaMutation({
 *   variables: {
 *      designId: // value for 'designId'
 *      mediaEntryId: // value for 'mediaEntryId'
 *      media: // value for 'media'
 *   },
 * });
 */
export function useEditMediaMutation(baseOptions?: Apollo.MutationHookOptions<EditMediaMutation, EditMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditMediaMutation, EditMediaMutationVariables>(EditMediaDocument, options);
      }
export type EditMediaMutationHookResult = ReturnType<typeof useEditMediaMutation>;
export type EditMediaMutationResult = Apollo.MutationResult<EditMediaMutation>;
export type EditMediaMutationOptions = Apollo.BaseMutationOptions<EditMediaMutation, EditMediaMutationVariables>;
export const MeDocument = gql`
    query Me {
  me {
    ...Customer
  }
}
    ${CustomerFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const OrderDocument = gql`
    query Order($orderId: ID!) {
  orderStatus(orderId: $orderId) {
    ...Order
  }
  stock {
    ...Stock
  }
}
    ${OrderFragmentDoc}
${StockFragmentDoc}`;

/**
 * __useOrderQuery__
 *
 * To run a query within a React component, call `useOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useOrderQuery(baseOptions: Apollo.QueryHookOptions<OrderQuery, OrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
      }
export function useOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderQuery, OrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
        }
export type OrderQueryHookResult = ReturnType<typeof useOrderQuery>;
export type OrderLazyQueryHookResult = ReturnType<typeof useOrderLazyQuery>;
export type OrderQueryResult = Apollo.QueryResult<OrderQuery, OrderQueryVariables>;
export const OrderForPaymentDocument = gql`
    query OrderForPayment($orderId: ID!) {
  orderStatus(orderId: $orderId) {
    id
    paymentIntent {
      id
      amountInCents
      clientSecret
    }
  }
}
    `;

/**
 * __useOrderForPaymentQuery__
 *
 * To run a query within a React component, call `useOrderForPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderForPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderForPaymentQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useOrderForPaymentQuery(baseOptions: Apollo.QueryHookOptions<OrderForPaymentQuery, OrderForPaymentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderForPaymentQuery, OrderForPaymentQueryVariables>(OrderForPaymentDocument, options);
      }
export function useOrderForPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderForPaymentQuery, OrderForPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderForPaymentQuery, OrderForPaymentQueryVariables>(OrderForPaymentDocument, options);
        }
export type OrderForPaymentQueryHookResult = ReturnType<typeof useOrderForPaymentQuery>;
export type OrderForPaymentLazyQueryHookResult = ReturnType<typeof useOrderForPaymentLazyQuery>;
export type OrderForPaymentQueryResult = Apollo.QueryResult<OrderForPaymentQuery, OrderForPaymentQueryVariables>;
export const OrdersDocument = gql`
    query Orders($customerId: ID!) {
  customerOrders(customerId: $customerId) {
    ...Order
  }
}
    ${OrderFragmentDoc}`;

/**
 * __useOrdersQuery__
 *
 * To run a query within a React component, call `useOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useOrdersQuery(baseOptions: Apollo.QueryHookOptions<OrdersQuery, OrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrdersQuery, OrdersQueryVariables>(OrdersDocument, options);
      }
export function useOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrdersQuery, OrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrdersQuery, OrdersQueryVariables>(OrdersDocument, options);
        }
export type OrdersQueryHookResult = ReturnType<typeof useOrdersQuery>;
export type OrdersLazyQueryHookResult = ReturnType<typeof useOrdersLazyQuery>;
export type OrdersQueryResult = Apollo.QueryResult<OrdersQuery, OrdersQueryVariables>;
export const PreviewDocument = gql`
    query Preview($designId: ID!) {
  designPreview(designId: $designId) {
    playlistURL
  }
}
    `;

/**
 * __usePreviewQuery__
 *
 * To run a query within a React component, call `usePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewQuery({
 *   variables: {
 *      designId: // value for 'designId'
 *   },
 * });
 */
export function usePreviewQuery(baseOptions: Apollo.QueryHookOptions<PreviewQuery, PreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewQuery, PreviewQueryVariables>(PreviewDocument, options);
      }
export function usePreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewQuery, PreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewQuery, PreviewQueryVariables>(PreviewDocument, options);
        }
export type PreviewQueryHookResult = ReturnType<typeof usePreviewQuery>;
export type PreviewLazyQueryHookResult = ReturnType<typeof usePreviewLazyQuery>;
export type PreviewQueryResult = Apollo.QueryResult<PreviewQuery, PreviewQueryVariables>;
export const RemoveDestinationDocument = gql`
    mutation RemoveDestination($orderId: ID!, $designId: ID!, $destinationId: ID!) {
  removeDestination(
    orderId: $orderId
    designId: $designId
    destinationId: $destinationId
  ) {
    ...Order
  }
}
    ${OrderFragmentDoc}`;
export type RemoveDestinationMutationFn = Apollo.MutationFunction<RemoveDestinationMutation, RemoveDestinationMutationVariables>;

/**
 * __useRemoveDestinationMutation__
 *
 * To run a mutation, you first call `useRemoveDestinationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDestinationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDestinationMutation, { data, loading, error }] = useRemoveDestinationMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      designId: // value for 'designId'
 *      destinationId: // value for 'destinationId'
 *   },
 * });
 */
export function useRemoveDestinationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDestinationMutation, RemoveDestinationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDestinationMutation, RemoveDestinationMutationVariables>(RemoveDestinationDocument, options);
      }
export type RemoveDestinationMutationHookResult = ReturnType<typeof useRemoveDestinationMutation>;
export type RemoveDestinationMutationResult = Apollo.MutationResult<RemoveDestinationMutation>;
export type RemoveDestinationMutationOptions = Apollo.BaseMutationOptions<RemoveDestinationMutation, RemoveDestinationMutationVariables>;
export const RemoveExtraDocument = gql`
    mutation RemoveExtra($destinationId: ID!, $id: ID!) {
  removeExtra(destinationId: $destinationId, id: $id) {
    ...Order
  }
}
    ${OrderFragmentDoc}`;
export type RemoveExtraMutationFn = Apollo.MutationFunction<RemoveExtraMutation, RemoveExtraMutationVariables>;

/**
 * __useRemoveExtraMutation__
 *
 * To run a mutation, you first call `useRemoveExtraMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveExtraMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeExtraMutation, { data, loading, error }] = useRemoveExtraMutation({
 *   variables: {
 *      destinationId: // value for 'destinationId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveExtraMutation(baseOptions?: Apollo.MutationHookOptions<RemoveExtraMutation, RemoveExtraMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveExtraMutation, RemoveExtraMutationVariables>(RemoveExtraDocument, options);
      }
export type RemoveExtraMutationHookResult = ReturnType<typeof useRemoveExtraMutation>;
export type RemoveExtraMutationResult = Apollo.MutationResult<RemoveExtraMutation>;
export type RemoveExtraMutationOptions = Apollo.BaseMutationOptions<RemoveExtraMutation, RemoveExtraMutationVariables>;
export const ShippingOptionsDocument = gql`
    query ShippingOptions($destinationId: ID!) {
  shippingOptions(destinationId: $destinationId) {
    ...ShippingOption
  }
}
    ${ShippingOptionFragmentDoc}`;

/**
 * __useShippingOptionsQuery__
 *
 * To run a query within a React component, call `useShippingOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShippingOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShippingOptionsQuery({
 *   variables: {
 *      destinationId: // value for 'destinationId'
 *   },
 * });
 */
export function useShippingOptionsQuery(baseOptions: Apollo.QueryHookOptions<ShippingOptionsQuery, ShippingOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShippingOptionsQuery, ShippingOptionsQueryVariables>(ShippingOptionsDocument, options);
      }
export function useShippingOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShippingOptionsQuery, ShippingOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShippingOptionsQuery, ShippingOptionsQueryVariables>(ShippingOptionsDocument, options);
        }
export type ShippingOptionsQueryHookResult = ReturnType<typeof useShippingOptionsQuery>;
export type ShippingOptionsLazyQueryHookResult = ReturnType<typeof useShippingOptionsLazyQuery>;
export type ShippingOptionsQueryResult = Apollo.QueryResult<ShippingOptionsQuery, ShippingOptionsQueryVariables>;
export const StockDocument = gql`
    query Stock {
  stock {
    ...Stock
  }
}
    ${StockFragmentDoc}`;

/**
 * __useStockQuery__
 *
 * To run a query within a React component, call `useStockQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockQuery({
 *   variables: {
 *   },
 * });
 */
export function useStockQuery(baseOptions?: Apollo.QueryHookOptions<StockQuery, StockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StockQuery, StockQueryVariables>(StockDocument, options);
      }
export function useStockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StockQuery, StockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StockQuery, StockQueryVariables>(StockDocument, options);
        }
export type StockQueryHookResult = ReturnType<typeof useStockQuery>;
export type StockLazyQueryHookResult = ReturnType<typeof useStockLazyQuery>;
export type StockQueryResult = Apollo.QueryResult<StockQuery, StockQueryVariables>;
export const UpdateAddressDocument = gql`
    mutation UpdateAddress($destinationId: ID!, $address: AddressInput!) {
  updateAddress(destinationId: $destinationId, address: $address) {
    valid
    messages {
      type
      code
      message
    }
    order {
      ...Order
    }
  }
}
    ${OrderFragmentDoc}`;
export type UpdateAddressMutationFn = Apollo.MutationFunction<UpdateAddressMutation, UpdateAddressMutationVariables>;

/**
 * __useUpdateAddressMutation__
 *
 * To run a mutation, you first call `useUpdateAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddressMutation, { data, loading, error }] = useUpdateAddressMutation({
 *   variables: {
 *      destinationId: // value for 'destinationId'
 *      address: // value for 'address'
 *   },
 * });
 */
export function useUpdateAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAddressMutation, UpdateAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAddressMutation, UpdateAddressMutationVariables>(UpdateAddressDocument, options);
      }
export type UpdateAddressMutationHookResult = ReturnType<typeof useUpdateAddressMutation>;
export type UpdateAddressMutationResult = Apollo.MutationResult<UpdateAddressMutation>;
export type UpdateAddressMutationOptions = Apollo.BaseMutationOptions<UpdateAddressMutation, UpdateAddressMutationVariables>;
export const UpdateCoverDocument = gql`
    mutation UpdateCover($destinationId: ID!, $coverId: ID!) {
  updateCover(destinationId: $destinationId, coverId: $coverId) {
    ...Order
  }
}
    ${OrderFragmentDoc}`;
export type UpdateCoverMutationFn = Apollo.MutationFunction<UpdateCoverMutation, UpdateCoverMutationVariables>;

/**
 * __useUpdateCoverMutation__
 *
 * To run a mutation, you first call `useUpdateCoverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoverMutation, { data, loading, error }] = useUpdateCoverMutation({
 *   variables: {
 *      destinationId: // value for 'destinationId'
 *      coverId: // value for 'coverId'
 *   },
 * });
 */
export function useUpdateCoverMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCoverMutation, UpdateCoverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCoverMutation, UpdateCoverMutationVariables>(UpdateCoverDocument, options);
      }
export type UpdateCoverMutationHookResult = ReturnType<typeof useUpdateCoverMutation>;
export type UpdateCoverMutationResult = Apollo.MutationResult<UpdateCoverMutation>;
export type UpdateCoverMutationOptions = Apollo.BaseMutationOptions<UpdateCoverMutation, UpdateCoverMutationVariables>;
export const UpdateGiftMessageDocument = gql`
    mutation UpdateGiftMessage($destinationId: ID!, $message: MessageInput!) {
  updateGiftMessage(destinationId: $destinationId, message: $message) {
    ...Order
  }
}
    ${OrderFragmentDoc}`;
export type UpdateGiftMessageMutationFn = Apollo.MutationFunction<UpdateGiftMessageMutation, UpdateGiftMessageMutationVariables>;

/**
 * __useUpdateGiftMessageMutation__
 *
 * To run a mutation, you first call `useUpdateGiftMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGiftMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGiftMessageMutation, { data, loading, error }] = useUpdateGiftMessageMutation({
 *   variables: {
 *      destinationId: // value for 'destinationId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useUpdateGiftMessageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGiftMessageMutation, UpdateGiftMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGiftMessageMutation, UpdateGiftMessageMutationVariables>(UpdateGiftMessageDocument, options);
      }
export type UpdateGiftMessageMutationHookResult = ReturnType<typeof useUpdateGiftMessageMutation>;
export type UpdateGiftMessageMutationResult = Apollo.MutationResult<UpdateGiftMessageMutation>;
export type UpdateGiftMessageMutationOptions = Apollo.BaseMutationOptions<UpdateGiftMessageMutation, UpdateGiftMessageMutationVariables>;
export const UpdateMediaDocument = gql`
    mutation UpdateMedia($designID: ID!, $media: [ID!]!, $ifPrevGenerationMatches: ID) {
  updateMedia(
    designId: $designID
    media: $media
    ifPrevGenerationMatches: $ifPrevGenerationMatches
  ) {
    ...Design
  }
}
    ${DesignFragmentDoc}`;
export type UpdateMediaMutationFn = Apollo.MutationFunction<UpdateMediaMutation, UpdateMediaMutationVariables>;

/**
 * __useUpdateMediaMutation__
 *
 * To run a mutation, you first call `useUpdateMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMediaMutation, { data, loading, error }] = useUpdateMediaMutation({
 *   variables: {
 *      designID: // value for 'designID'
 *      media: // value for 'media'
 *      ifPrevGenerationMatches: // value for 'ifPrevGenerationMatches'
 *   },
 * });
 */
export function useUpdateMediaMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMediaMutation, UpdateMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMediaMutation, UpdateMediaMutationVariables>(UpdateMediaDocument, options);
      }
export type UpdateMediaMutationHookResult = ReturnType<typeof useUpdateMediaMutation>;
export type UpdateMediaMutationResult = Apollo.MutationResult<UpdateMediaMutation>;
export type UpdateMediaMutationOptions = Apollo.BaseMutationOptions<UpdateMediaMutation, UpdateMediaMutationVariables>;
export const UpdateOrientationDocument = gql`
    mutation UpdateOrientation($designId: ID!, $orientation: Orientation) {
  updateOrientation(designId: $designId, orientation: $orientation) {
    design {
      ...Design
    }
  }
}
    ${DesignFragmentDoc}`;
export type UpdateOrientationMutationFn = Apollo.MutationFunction<UpdateOrientationMutation, UpdateOrientationMutationVariables>;

/**
 * __useUpdateOrientationMutation__
 *
 * To run a mutation, you first call `useUpdateOrientationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrientationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrientationMutation, { data, loading, error }] = useUpdateOrientationMutation({
 *   variables: {
 *      designId: // value for 'designId'
 *      orientation: // value for 'orientation'
 *   },
 * });
 */
export function useUpdateOrientationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrientationMutation, UpdateOrientationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrientationMutation, UpdateOrientationMutationVariables>(UpdateOrientationDocument, options);
      }
export type UpdateOrientationMutationHookResult = ReturnType<typeof useUpdateOrientationMutation>;
export type UpdateOrientationMutationResult = Apollo.MutationResult<UpdateOrientationMutation>;
export type UpdateOrientationMutationOptions = Apollo.BaseMutationOptions<UpdateOrientationMutation, UpdateOrientationMutationVariables>;
export const UpdateQuantityDocument = gql`
    mutation UpdateQuantity($destinationId: ID!, $quantity: Int!) {
  updateQuantity(destinationId: $destinationId, quantity: $quantity) {
    ...Order
  }
}
    ${OrderFragmentDoc}`;
export type UpdateQuantityMutationFn = Apollo.MutationFunction<UpdateQuantityMutation, UpdateQuantityMutationVariables>;

/**
 * __useUpdateQuantityMutation__
 *
 * To run a mutation, you first call `useUpdateQuantityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuantityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuantityMutation, { data, loading, error }] = useUpdateQuantityMutation({
 *   variables: {
 *      destinationId: // value for 'destinationId'
 *      quantity: // value for 'quantity'
 *   },
 * });
 */
export function useUpdateQuantityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuantityMutation, UpdateQuantityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuantityMutation, UpdateQuantityMutationVariables>(UpdateQuantityDocument, options);
      }
export type UpdateQuantityMutationHookResult = ReturnType<typeof useUpdateQuantityMutation>;
export type UpdateQuantityMutationResult = Apollo.MutationResult<UpdateQuantityMutation>;
export type UpdateQuantityMutationOptions = Apollo.BaseMutationOptions<UpdateQuantityMutation, UpdateQuantityMutationVariables>;
export const UpdateShippingChoiceDocument = gql`
    mutation UpdateShippingChoice($destinationId: ID!, $choice: ShippingChoice!) {
  updateShippingChoice(destinationId: $destinationId, choice: $choice) {
    ...Order
  }
}
    ${OrderFragmentDoc}`;
export type UpdateShippingChoiceMutationFn = Apollo.MutationFunction<UpdateShippingChoiceMutation, UpdateShippingChoiceMutationVariables>;

/**
 * __useUpdateShippingChoiceMutation__
 *
 * To run a mutation, you first call `useUpdateShippingChoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShippingChoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShippingChoiceMutation, { data, loading, error }] = useUpdateShippingChoiceMutation({
 *   variables: {
 *      destinationId: // value for 'destinationId'
 *      choice: // value for 'choice'
 *   },
 * });
 */
export function useUpdateShippingChoiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateShippingChoiceMutation, UpdateShippingChoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateShippingChoiceMutation, UpdateShippingChoiceMutationVariables>(UpdateShippingChoiceDocument, options);
      }
export type UpdateShippingChoiceMutationHookResult = ReturnType<typeof useUpdateShippingChoiceMutation>;
export type UpdateShippingChoiceMutationResult = Apollo.MutationResult<UpdateShippingChoiceMutation>;
export type UpdateShippingChoiceMutationOptions = Apollo.BaseMutationOptions<UpdateShippingChoiceMutation, UpdateShippingChoiceMutationVariables>;